import pptxgen from 'pptxgenjs';
import garment1 from '../../pages/catalogue/formatsPage/garment4.jpg';
import ip from '@/GlobelIP';
import { FaFighterJet } from 'react-icons/fa';
const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64 = reader.result as string;
      resolve(base64.split(',')[1]); // remove data prefix
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
const addLastSlideSafe = async ({ ppt, buyercata = [], catappt = [], ip }) => {
  if (!ppt) return;

  const buyerLast =
    buyercata?.length &&
    buyercata[0]?.attributes?.LastSlide === 'Yes' &&
    buyercata[0]?.attributes?.LSPath?.data?.attributes?.url;

  const cataLast =
    catappt?.length &&
    catappt[0]?.attributes?.LastSlide === 'Yes' &&
    catappt[0]?.attributes?.LSPath?.data?.attributes?.url;

  const imageUrl = buyerLast
    ? `${ip}${buyercata[0].attributes.LSPath.data.attributes.url}`
    : cataLast
    ? `${ip}${catappt[0].attributes.LSPath.data.attributes.url}`
    : null;

  if (!imageUrl) return;

  // ensure image loads before PPT export
  await new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = reject;
    img.src = imageUrl;
  });

  const slide = ppt.addSlide();
  slide.addImage({
    path: imageUrl,
    x: 0,
    y: 0,
    w: '100%',
    h: '100%'
  });
};
const generatePPTBlobForEmail = async (
  cata,
  buyername,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  sizeshow,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm
  {
    // console.log('handleDownloadPPT1');
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };
    const addIntroductionSlide = ppt => {
      const slide = ppt.addSlide();
      const image =
        buyername &&
        buyercata?.length > 0 &&
        buyercata[0]?.attributes?.CSPath?.data?.attributes?.url
          ? buyercata[0].attributes.CSPath.data.attributes.url
          : catappt?.[0]?.attributes?.CSPath?.data?.attributes?.url;

      // let logoImageUrl = garment1;
      const logoImageUrl = image;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };

        slide.addImage({ path: img, ...logoOptions });
      }
    };

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }

    const addProductSlide = async (product, serialNumber, catalgoue, ppt) => {
      const slide = ppt.addSlide();
      // Define the background color for the slide
      const slideBackgroundColor = {
        x: 0.15,
        y: 0.1,
        w: '55%',
        h: '95.5%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColor);
      const slideBackgroundColorc = {
        x: 6,
        y: 0.1,
        w: '38%',
        h: '40%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColorc);
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      try {
        // Wait for the image to load and get its size
        const { width, height } = await getImageSize(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }

        // Define the maximum width and height for the image on the slide (adjust these values as needed)
        const maxWidth = 4.4; // Maximum width in inches
        const maxHeight = 5.1; // Maximum height in inches

        // Calculate the aspect ratio
        const aspectRatio = width / height;

        // Scale the image to fit within the slide's boundaries
        let imageWidth = width;
        let imageHeight = height;

        // Check if the image exceeds the max dimensions and scale it down
        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            // Scale by width if the image is wider than tall
            imageWidth = maxWidth;
            imageHeight = maxWidth / aspectRatio;
          } else {
            // Scale by height if the image is taller than wide
            imageHeight = maxHeight;
            imageWidth = maxHeight * aspectRatio;
          }
        }

        // Ensure the image is constrained within the slide's width and height
        if (imageWidth > maxWidth) imageWidth = maxWidth;
        if (imageHeight > maxHeight) imageHeight = maxHeight;

        const imageOptions = {
          x: 0.6,
          y: 0.25,
          w: imageWidth, // Use scaled width
          h: imageHeight // Use scaled height
        };

        slide.addImage({ path: image, ...imageOptions });
      } catch (err) {
        console.error('Error loading image:', err);
      }

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 2; // Adjust the width of each image
        const imageHeight = 2; // Adjust the height of each image
        const xOffset = 6.9; // Adjust the x-offset of the images
        const yOffset = 0.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(1, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          let image = imageUrl;
          if (watermark) {
            const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

            // Convert Base64 to ArrayBuffer
            const response = await fetch(mergedImageBase64);
            const imageBuffer = await response.arrayBuffer();
            const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

            // Create a URL from the Blob
            const imageUrl2 = URL.createObjectURL(blob);
            image = imageUrl2;
          }
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: image, ...imageOptions });
        }
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value
      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                bold: true,
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                bold: true,
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const productnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const productnameValCell = {
              text: `${catalogItem.productname}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              productnameAttrCell,
              { ...productnameValCell, options: { ...productnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const discValCell = {
              text: `${catalogItem.description}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          {
            sizeshow
              ? // Code to display or handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `${label[0]?.attributes.SizeRange}`,
                    options: {
                      fontSize: 10,
                      fontFace: 'raleway',
                      color: '#000000',
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'raleway',
                      color: '#000000',
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Code to display or handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let sizeValue = '';
                  if (
                    'unit' in catalogItem &&
                    'len' in catalogItem &&
                    'wid' in catalogItem &&
                    'thick' in catalogItem
                  ) {
                    sizeValue = `${catalogItem.len}x${catalogItem.wid}x${catalogItem.thick} ${catalogItem.unit}`;
                  }
                  if (sizeValue) {
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'raleway',
                        color: '#000000',
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: `${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'raleway',
                        color: '#000000',
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }

          if (selectedItems.includes('productfinish')) {
            const finisheAttrCell = {
              text: `${label[0]?.attributes.finish}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const finidhValCell = {
              text: `${catalogItem.finish}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              finisheAttrCell,
              { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.NetWgt}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.netwgt}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsalepri')) {
            let price = '';
            if ('currency' in catalogItem && 'saleprice' in catalogItem) {
              price = `${catalogItem.currency} ${catalogItem.saleprice}`;
            }
            if (price) {
              const sizeAttrCell = {
                text: 'Price',
                options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
              };
              const sizeValCell = {
                text: `${price}`,
                options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
              };
              tableRows.push([
                sizeAttrCell,
                { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.cbm}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });

      const tableOptions = {
        x: 5.9,
        y: 2.4,
        w: '40%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: false // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // let serialCounter = 1;
    // setLoadPPT(true);

    // for (let item of cata) {
    //   await addProductSlide(item, serialCounter, cataloguecatappt);
    //   serialCounter++; // Ensure to await each slide creation
    // }
    // // Download the PPT file
    // ppt
    //   .writeFile({ fileName: `${cataName} PPt.pptx` })
    //   .then(res => {
    //     setLoadPPT(false);
    //     setOpenAttri(false);
    //   })
    //   .catch(err => console.log(err));

    setLoadPPT(true);
    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      const blob = await ppt.write('blob');

      const base64 = await blobToBase64(blob);
      catalogueIndex++;

      return {
        filename: fileName,
        blob,
        base64
      };
    } else {
      // If `cata` is a multidimensional array (e.g., array of catalogues)
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        // const headerimg = catappt[0]?.attributes?.HPath;
        // const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (catacover === 'Yes' || catacoverb === 'Yes') {
          await addIntroductionSlide(ppt); // Pass ppt is not needed
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        const blob = await ppt.write('blob');

        const base64 = await blobToBase64(blob);
        catalogueIndex++;

        return {
          filename: fileName,
          blob,
          base64
        };
      }
    }
    setLoadPPT(false);
    setOpen(false);
    setOpenAttri(false);
  };
const convertDimension = (value, fromUnit, toUnit) => {
  if (!value || isNaN(value)) return value;

  const num = parseFloat(value);

  // Same unit → no conversion
  if (fromUnit === toUnit) return num;

  // cm → inch
  if (fromUnit === 'cm' && toUnit === 'inch') {
    return +(num / 2.54).toFixed(2);
  }

  // inch → cm
  if (fromUnit === 'inch' && toUnit === 'cm') {
    return +(num * 2.54).toFixed(2);
  }

  return num;
};

const handleDownloadPPT1 = async (
  cata,
  buyername,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  sizeshow,
  unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm
  {
    console.log(buyername, buyercata, catappt);
    // console.log('handleDownloadPPT1');
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };
    const addIntroductionSlide = ppt => {
      const slide = ppt.addSlide();
      const image =
        buyername &&
        buyercata?.length > 0 &&
        buyercata[0]?.attributes?.CSPath?.data?.attributes?.url
          ? buyercata[0].attributes.CSPath.data.attributes.url
          : catappt?.[0]?.attributes?.CSPath?.data?.attributes?.url;

      // let logoImageUrl = garment1;
      const logoImageUrl = image;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };

        slide.addImage({ path: img, ...logoOptions });
      }
    };
    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }

    const addProductSlide = async (product, serialNumber, catalgoue, ppt) => {
      const slide = ppt.addSlide();
      // Define the background color for the slide
      const slideBackgroundColor = {
        x: 0.15,
        y: 0.1,
        w: '55%',
        h: '95.5%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColor);
      const slideBackgroundColorc = {
        x: 6,
        y: 0.1,
        w: '38%',
        h: '40%',
        fill: '#FFFFFF', // Set the background color here
        line: {
          color: '#000000',
          width: 0.5
        }
      };

      slide.addShape('rect', slideBackgroundColorc);
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      try {
        // Wait for the image to load and get its size
        const { width, height } = await getImageSize(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }

        // Define the maximum width and height for the image on the slide (adjust these values as needed)
        const maxWidth = 4.4; // Maximum width in inches
        const maxHeight = 5.1; // Maximum height in inches

        // Calculate the aspect ratio
        const aspectRatio = width / height;

        // Scale the image to fit within the slide's boundaries
        let imageWidth = width;
        let imageHeight = height;

        // Check if the image exceeds the max dimensions and scale it down
        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            // Scale by width if the image is wider than tall
            imageWidth = maxWidth;
            imageHeight = maxWidth / aspectRatio;
          } else {
            // Scale by height if the image is taller than wide
            imageHeight = maxHeight;
            imageWidth = maxHeight * aspectRatio;
          }
        }

        // Ensure the image is constrained within the slide's width and height
        if (imageWidth > maxWidth) imageWidth = maxWidth;
        if (imageHeight > maxHeight) imageHeight = maxHeight;

        const imageOptions = {
          x: 0.6,
          y: 0.25,
          w: imageWidth, // Use scaled width
          h: imageHeight // Use scaled height
        };

        slide.addImage({ path: image, ...imageOptions });
      } catch (err) {
        console.error('Error loading image:', err);
      }

      if (
        product.attributes.MultipleImage &&
        product.attributes.MultipleImage.data &&
        product.attributes.MultipleImage.data.length > 0
      ) {
        const multipleImages = product.attributes.MultipleImage.data;
        const imageWidth = 2; // Adjust the width of each image
        const imageHeight = 2; // Adjust the height of each image
        const xOffset = 6.9; // Adjust the x-offset of the images
        const yOffset = 0.2; // Adjust the initial y-offset of the images

        // Loop through the first two images or the available number of images
        const maxImages = Math.min(1, multipleImages.length);
        for (let index = 0; index < maxImages; index++) {
          const img = multipleImages[index];
          const imageUrl = `${ip}${img.attributes.url}`;
          let image = imageUrl;
          if (watermark) {
            const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

            // Convert Base64 to ArrayBuffer
            const response = await fetch(mergedImageBase64);
            const imageBuffer = await response.arrayBuffer();
            const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

            // Create a URL from the Blob
            const imageUrl2 = URL.createObjectURL(blob);
            image = imageUrl2;
          }
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: imageWidth,
            h: imageHeight
          };
          slide.addImage({ path: image, ...imageOptions });
        }
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value
      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                bold: true,
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                bold: true,
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const productnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const productnameValCell = {
              text: `${catalogItem.productname}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              productnameAttrCell,
              { ...productnameValCell, options: { ...productnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const discValCell = {
              text: `${catalogItem.description}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          {
            sizeshow
              ? // Code to display or handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `${label[0]?.attributes.SizeRange}`,
                    options: {
                      fontSize: 10,
                      fontFace: 'raleway',
                      color: '#000000',
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'raleway',
                      color: '#000000',
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Code to display or handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let sizeValue = '';
                  if (
                    'unit' in catalogItem &&
                    'len' in catalogItem &&
                    'wid' in catalogItem &&
                    'thick' in catalogItem
                  ) {
                    const originalUnit = catalogItem.unit?.toLowerCase().includes('inch')
                      ? 'inch'
                      : 'cm';

                    const selectedUnit = unit.toLowerCase();

                    const l = convertDimension(catalogItem.len || 0, originalUnit, selectedUnit);
                    const w = convertDimension(catalogItem.wid || 0, originalUnit, selectedUnit);
                    const h = convertDimension(catalogItem.thick || 0, originalUnit, selectedUnit);

                    sizeValue = `${l}x${w}x${h} ${selectedUnit}`;
                    // sizeValue = `${catalogItem.len}x${catalogItem.wid}x${catalogItem.thick} ${catalogItem.unit}`;
                  }
                  if (sizeValue) {
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'raleway',
                        color: '#000000',
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: `${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'raleway',
                        color: '#000000',
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }

          if (selectedItems.includes('productfinish')) {
            const finisheAttrCell = {
              text: `${label[0]?.attributes.finish}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const finidhValCell = {
              text: `${catalogItem.finish}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              finisheAttrCell,
              { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.NetWgt}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.netwgt}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsalepri')) {
            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;

            if (price) {
              const sizeAttrCell = {
                text: 'Price',
                options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
              };

              const sizeValCell = {
                text: formattedPrice, // 👈 use formatted string here
                options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
              };

              tableRows.push([
                sizeAttrCell,
                { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
              ]);

              yOffset += 0.1;
            }
          }

          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: { fontSize: 10, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            const ntValCell = {
              text: `${catalogItem.cbm}`,
              options: { fontSize: 8, fontFace: 'raleway', color: '#000000', valign: 'middle' }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });

      const tableOptions = {
        x: 5.9,
        y: 2.4,
        w: '40%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: false // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // let serialCounter = 1;
    // setLoadPPT(true);

    // for (let item of cata) {
    //   await addProductSlide(item, serialCounter, cataloguecatappt);
    //   serialCounter++; // Ensure to await each slide creation
    // }
    // // Download the PPT file
    // ppt
    //   .writeFile({ fileName: `${cataName} PPt.pptx` })
    //   .then(res => {
    //     setLoadPPT(false);
    //     setOpenAttri(false);
    //   })
    //   .catch(err => console.log(err));

    setLoadPPT(true);
    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    } else {
      // If `cata` is a multidimensional array (e.g., array of catalogues)
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        // const headerimg = catappt[0]?.attributes?.HPath;
        // const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (catacover === 'Yes' || catacoverb === 'Yes') {
          await addIntroductionSlide(ppt); // Pass ppt is not needed
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        // await addLastSlideSafe(ppt);
        await ppt.writeFile({ fileName });

        catalogueIndex++;
      }
    }
    setLoadPPT(false);
    setOpen(false);
    setOpenAttri(false);
  };
const handleDownloadPPT2 = async (
  cata,
  buyername,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  sizeshow,
  unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm,
  // ptech,
  // madeby
  {
    // console.log('handleDownloadPPT2');
    // console.log(ptech);
    // console.log('ptech');

    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };
    const addHeaderToSlide = slide => {
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const logoImageUrl = firstItem?.attributes.HPath.data.attributes.url || '';
      const container = {
        x: 0, // Horizontal position (left)
        y: 0, // Vertical position (top)
        w: '100%', // Full width of the slide
        h: 1 // Height of the container (can adjust as needed)
        // fill: 'red'  // Set the background color to red
      };
      slide.addShape('rect', container);

      if (logoImageUrl) {
        const logoFullPath = `${ip}${logoImageUrl}`;

        // Set max dimensions for the logo
        const maxWidth = 7;
        const maxHeight = 0.8;

        // Dynamically calculate the image dimensions to maintain aspect ratio
        const image = new Image();
        image.src = logoFullPath;

        image.onload = () => {
          const { naturalWidth, naturalHeight } = image;
          const aspectRatio = naturalWidth / naturalHeight;

          let logoWidth = maxWidth;
          let logoHeight = maxWidth / aspectRatio;

          // If height exceeds maxHeight, adjust width accordingly
          if (logoHeight > maxHeight) {
            logoHeight = maxHeight;
            logoWidth = maxHeight * aspectRatio;
          }

          // Center the image in the container
          const containerWidth = maxWidth; // Assuming the container's width matches maxWidth
          const containerHeight = maxHeight; // Assuming the container's height matches maxHeight

          const centeredX = (containerWidth - logoWidth) / 2 + 1.5; // Adjust for container padding
          const centeredY = (containerHeight - logoHeight) / 2 + 0.2; // Adjust for container padding

          const logoOptions = {
            x: centeredX, // Centered horizontally
            y: centeredY, // Centered vertically
            w: logoWidth,
            h: logoHeight
          };

          const logoFullPath = `${ip}${logoImageUrl}`;
          slide.addImage({ path: logoFullPath, ...logoOptions });
        };
      }
    };
    const addIntroductionSlide = async ppt => {
      const slide = ppt.addSlide();
      const image =
        buyername &&
        buyercata?.length > 0 &&
        buyercata[0]?.attributes?.CSPath?.data?.attributes?.url
          ? buyercata[0].attributes.CSPath.data.attributes.url
          : catappt?.[0]?.attributes?.CSPath?.data?.attributes?.url;

      const logoImageUrl = image;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: 5.6 // Adjust the height of the logo
        };
        slide.addImage({ path: img, ...logoOptions });
      }
    };

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const headerimg = catappt[0]?.attributes?.HPath;
    // if (headerimg == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const headerimgb = buyercata[0]?.attributes?.HPath;
    // if (headerimgb == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catah = catappt[0]?.attributes?.Header;
    // const catahb = buyercata[0]?.attributes?.Header;
    const addProductSlide = async (product, serialNumber, catalgoue, ppt, catah, catahb) => {
      const topGap = 0.5;
      const slide = ppt.addSlide();
      if (catah == 'Yes') {
        addHeaderToSlide(slide);
      }
      if (catahb == 'Yes') {
        addHeaderToSlide(slide);
      }

      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

      try {
        // Wait for the image to load and get its size
        const { width, height } = await getImageSize(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }
        // Define the maximum width and height for the image on the slide (adjust these values as needed)
        const maxWidth = 5; // Maximum width in inches
        const maxHeight = 3.1; // Maximum height in inches

        // Calculate the aspect ratio
        const aspectRatio = width / height;

        // Scale the image to fit within the slide's boundaries
        let imageWidth = width;
        let imageHeight = height;

        // Check if the image exceeds the max dimensions and scale it down
        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            // Scale by width if the image is wider than tall
            imageWidth = maxWidth;
            imageHeight = maxWidth / aspectRatio;
          } else {
            // Scale by height if the image is taller than wide
            imageHeight = maxHeight;
            imageWidth = maxHeight * aspectRatio;
          }
        }

        // Ensure the image is constrained within the slide's width and height
        if (imageWidth > maxWidth) imageWidth = maxWidth;
        if (imageHeight > maxHeight) imageHeight = maxHeight;

        const imageOptions = {
          x: 0.6,
          y: 0.8 + topGap,
          w: imageWidth, // Use scaled width
          h: imageHeight // Use scaled height
        };

        slide.addImage({ path: image, ...imageOptions });
      } catch (err) {
        console.error('Error loading image:', err);
      }

      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1 + topGap; // Adjust the initial y-coordinate value

      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const productnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const productnameValCell = {
              text: `${catalogItem.productname}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productnameAttrCell,
              { ...productnameValCell, options: { ...productnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const rangeAttrCell = {
                    text: `${label[0]?.attributes.SizeRange}`,
                    options: {
                      fontSize: 10,
                      fontFace: 'raleway',
                      color: '#000000',
                      border: { pt: 1, color: '#808080' },
                      valign: 'middle'
                    }
                  };
                  const rangeValCell = {
                    text: `${catalogItem.SizeRange}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'raleway',
                      color: '#000000',
                      border: { pt: 1, color: '#808080' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    rangeAttrCell,
                    { ...rangeValCell, options: { ...rangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let sizeValue = '';

                  if (
                    catalogItem.unit &&
                    catalogItem.len != null &&
                    catalogItem.wid != null &&
                    catalogItem.thick != null
                  ) {
                    const recordUnit = catalogItem.unit.toLowerCase();
                    const targetUnit = unit.toLowerCase();

                    let len = Number(catalogItem.len);
                    let wid = Number(catalogItem.wid);
                    let thick = Number(catalogItem.thick);

                    if (recordUnit !== targetUnit) {
                      // cm → inch
                      if (recordUnit === 'cm' && targetUnit === 'inch') {
                        len = len / 2.54;
                        wid = wid / 2.54;
                        thick = thick / 2.54;
                      }

                      // inch → cm
                      else if (recordUnit === 'inch' && targetUnit === 'cm') {
                        len = len * 2.54;
                        wid = wid * 2.54;
                        thick = thick * 2.54;
                      }
                    }

                    len = Number(len.toFixed(2));
                    wid = Number(wid.toFixed(2));
                    thick = Number(thick.toFixed(2));

                    sizeValue = `${len}x${wid}x${thick} ${targetUnit}`;
                  }

                  if (sizeValue) {
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'raleway',
                        color: '#000000',
                        border: { pt: 1, color: '#808080' },
                        valign: 'middle'
                      }
                    };

                    const sizeValCell = {
                      text: sizeValue,
                      options: {
                        fontSize: 8,
                        fontFace: 'raleway',
                        color: '#000000',
                        border: { pt: 1, color: '#808080' },
                        valign: 'middle'
                      }
                    };

                    tableRows.push([sizeAttrCell, sizeValCell]);
                    yOffset += 0.1;
                  }
                })();
          }

          if (selectedItems.includes('productfinish')) {
            const finisheAttrCell = {
              text: `${label[0]?.attributes.finish}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const finidhValCell = {
              text: `${catalogItem.finish}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              finisheAttrCell,
              { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsalepri')) {
            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;

            if (price) {
              const priceAttrCell = {
                text: 'Price',
                options: {
                  fontSize: 10,
                  fontFace: 'raleway',
                  color: '#000000',
                  border: { pt: 1, color: '#808080' },
                  valign: 'middle'
                }
              };

              const priceValCell = {
                text: formattedPrice,
                options: {
                  fontSize: 8,
                  fontFace: 'raleway',
                  color: '#000000',
                  border: { pt: 1, color: '#808080' },
                  valign: 'middle'
                }
              };

              tableRows.push([priceAttrCell, priceValCell]);
              yOffset += 0.1;
            }
          }

          if (selectedItems.includes('productntw')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.NetWgt}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.netwgt}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('ptech')) {
            const ptAttrCell = {
              text: `${label[0]?.attributes.P_Technique}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ptValCell = {
              text: `${product?.attributes?.P_Technique}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ptAttrCell,
              { ...ptValCell, options: { ...ptValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('madeby')) {
            const mdAttrCell = {
              text: `${label[0]?.attributes.MadeBy}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const mdValCell = {
              text: `${product?.attributes?.MadeBy}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              mdAttrCell,
              { ...mdValCell, options: { ...mdValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });

      const tableOptions = {
        x: 6,
        y: 0.8 + topGap,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: false // Enable automatic paging if the table exceeds slide size
      };

      if (tableRows.length > 0) {
        slide.addTable(tableRows, tableOptions);
      } else {
        console.warn('Skipping table for product due to no valid rows.');
      }
      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 10,
              fontFace: 'Arial',
              color: '#000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 9, y: 5.25 + topGap } // Adjust the position as needed
      );
      const lineOptionsnot = {
        x: 9, // X-coordinate of the line's starting point
        y: 0, // Y-coordinate of the line's starting point (just below the text)
        w: '5%', // Adjust the width of the line as needed
        h: 0.6, // Height of the line (adjust as needed)
        fill: '#d6d1cd' // Line color
      };
      slide.addShape('rect', lineOptionsnot);

      const lineOptionsnob = {
        x: 0.6, // X-coordinate of the line's starting point
        y: 5.03, // Y-coordinate of the line's starting point (just below the text)
        w: '5%', // Adjust the width of the line as needed
        h: 0.6, // Height of the line (adjust as needed)
        fill: '#d6d1cd' // Line color
      };
      slide.addShape('rect', lineOptionsnob);
    };
    setLoadPPT(true);
    // console.log('cata inside ppt', cata);
    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      const headerimg = catappt[0]?.attributes?.HPath;
      const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (
        catacover === 'Yes' ||
        catacoverb === 'Yes' ||
        headerimg === 'Yes' ||
        headerimgb === 'Yes'
      ) {
        await addIntroductionSlide(ppt); // ✅ Pass ppt
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt, catah, catahb); // ✅ Pass ppt
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    } else {
      let catalogueIndex = 1;
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        const headerimg = catappt[0]?.attributes?.HPath;
        const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (
          catacover === 'Yes' ||
          catacoverb === 'Yes' ||
          headerimg === 'Yes' ||
          headerimgb === 'Yes'
        ) {
          await addIntroductionSlide(ppt); // ✅ Pass ppt
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt, catah, catahb); // ✅ Pass ppt
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        await ppt.writeFile({ fileName });

        catalogueIndex++;
      }
    }
    setLoadPPT(false);
    setOpenAttri(false);
    setOpen(false);
  };
const handleDownloadPPT3 = async (
  cata,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  catalogueCatProductSize,
  sizeshow,
  unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm,
  // productMaterialName,
  // productInnerAndMaster,
  // productMoq,
  // ptech,
  // madeby
  {
    // console.log('handleDownloadPPT3');
    // const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };

    const response = await fetch(`${ip}/api/mstfinishes?populate=*&pagination[pageSize]=100000`);
    const finish = await response.json();

    const addHeaderToSlide = slide => {
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
      const container = {
        x: 0, // Horizontal position (left)
        y: 0, // Vertical position (top)
        w: 10, // Full width of the slide (adjust as needed)
        h: 1 // Height of the container (adjust as needed)
      };
      slide.addShape('rect', container);

      if (logoImageUrl) {
        const logoFullPath = `${ip}${logoImageUrl}`;

        // Load the image to get its natural dimensions
        const image = new Image();
        image.src = logoFullPath;

        image.onload = () => {
          const { naturalWidth, naturalHeight } = image;

          // Maintain aspect ratio and scale to fit the container
          const containerAspectRatio = container.w / container.h;
          const imageAspectRatio = naturalWidth / naturalHeight;

          let scaledWidth, scaledHeight, offsetX, offsetY;

          if (imageAspectRatio > containerAspectRatio) {
            // Image is wider than the container
            scaledWidth = container.w;
            scaledHeight = container.w / imageAspectRatio;
            offsetX = 0;
            offsetY = (container.h - scaledHeight) / 2; // Center vertically
          } else {
            // Image is taller or equal aspect ratio
            scaledWidth = container.h * imageAspectRatio;
            scaledHeight = container.h;
            offsetX = (container.w - scaledWidth) / 2; // Center horizontally
            offsetY = 0;
          }

          // Add the image to the slide
          slide.addImage({
            path: logoFullPath,
            x: container.x + offsetX,
            y: container.y + offsetY,
            w: scaledWidth,
            h: scaledHeight
          });
        };

        image.onerror = () => {
          console.error('Error loading image:', logoFullPath);
        };
      }
    };

    const addIntroductionSlide = ppt => {
      const slide = ppt.addSlide();
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%', // Width spans the entire slide
          h: 5.6, // Height of the header area
          fill: '#eff1f0' // Background color for the header
        };
        // const logoOptions = {
        //   x: 1.2, // Adjust the x-coordinate of the logo
        //   y: 0.6, // Adjust the y-coordinate of the logo
        //   w: 1, // Adjust the width of the logo
        //   h: 0.3 // Adjust the height of the logo
        // };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catah = catappt[0]?.attributes?.Header;
    // const catahb = buyercata[0]?.attributes?.Header;
    const addProductSlide = async (product, serialNumber, catalgoue, ppt, catah, catahb) => {
      const slide = ppt.addSlide();
      if (catah === 'Yes') addHeaderToSlide(slide);
      if (catahb === 'Yes') addHeaderToSlide(slide);

      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      const watermarkUrl2 = watermarkUrl || ''; // Use state to

      try {
        // Create a container (a rectangle shape) with the specified dimensions (4 x 2.1 inches)
        const containerWidth = 4.7; // Container width in inches
        const containerHeight = 4.3; // Container height in inches

        // Create a red background for the container
        const containerOptions = {
          x: 0.5, // Starting X position for the container
          y: 1, // Starting Y position for the container
          w: containerWidth,
          h: containerHeight // Set the background color to red
          // fill: { color: 'FF0000' }
        };

        // Add the rectangle container to the slide
        slide.addShape('rect', containerOptions);

        // Add the CoverImage to the container
        const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

        const { width, height } = await getImageSize(imageUrl);
        let image = imageUrl;

        if (watermark && watermarkUrl) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' });

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }

        // Max width and height of the image within the container (adjusted for margin)
        const maxWidth = containerWidth - 0.1; // 1-inch margin for better positioning
        const maxHeight = containerHeight - 0.1; // 1-inch margin for better positioning

        const aspectRatio = width / height;
        let imageWidth = width;
        let imageHeight = height;

        // Scale the image if it exceeds container's size
        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            imageWidth = maxWidth;
            imageHeight = maxWidth / aspectRatio;
          } else {
            imageHeight = maxHeight;
            imageWidth = maxHeight * aspectRatio;
          }
        }

        // Ensure image does not overflow container
        imageWidth = Math.min(imageWidth, maxWidth);
        imageHeight = Math.min(imageHeight, maxHeight);

        // Calculate the x and y to center the image within the container
        const x = (containerWidth - imageWidth) / 2; // Center horizontally within the container
        const y = 0; // Center vertically within the container

        // Image options with centered position
        const imageOptions = {
          x: 0.3 + x, // Adjusting for the margin added to the container
          y: 0.9 + y, // Adjusting for the margin added to the container
          w: imageWidth,
          h: imageHeight
        };

        // Add the CoverImage to the container (red background)
        slide.addImage({ path: image, ...imageOptions });
      } catch (err) {
        console.error('Error creating container or adding images:', err);
      }
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const pnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            // Split by words, chunk into 2 lines, then join with newline
            const fullName = `${catalogItem.productname || ''}`;
            const words = fullName.split(' ');
            const line1 = words.slice(0, 6).join(' '); // Adjust word count as needed
            const line2 = words.slice(6, 12).join(' ');
            const truncatedText = [line1, line2].filter(Boolean).join('\n');
            const pnameValCell = {
              text: truncatedText,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              pnameAttrCell,
              { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsize')) {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `Size`,
                    options: {
                      fontSize: 10,
                      fontFace: 'Arial',
                      color: '#000000',
                      fill: '#afafaf',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'Arial',
                      color: '#595959',
                      fill: '#E5E4E2',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let allSize;
                  if (product.attributes.SetStatus === 'Set') {
                    allSize = catalogueCatProductSize.filter(
                      item => item.CatalogueProduct === catalogItem.CatalogProduct
                    );

                    const sizeValues = allSize
                      .slice(0, 3)
                      .map(item => {
                        const { Description, Length, Width, Height, Unit } = item;

                        if (Length === 0 && Width === 0 && Height === 0) {
                          return '';
                        }

                        const descText = Description !== 'null' ? `${Description} - ` : '';
                        return `${descText}${Length} x ${Width} x ${Height} ${Unit}`;
                      })
                      .join('\n'); // Joining values with a new line for better readability

                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Arial',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'top'
                      }
                    };

                    const sizeValCell = {
                      text: sizeValues, // All values in a single cell
                      options: {
                        fontSize: 8,
                        fontFace: 'Arial',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };

                    tableRows.push([sizeAttrCell, sizeValCell]); // Adding a single row
                  } else {
                    const convertedLen = convertDimension(catalogItem.len, catalogItem.unit, unit);

                    const convertedWid = convertDimension(catalogItem.wid, catalogItem.unit, unit);

                    const convertedThick = convertDimension(
                      catalogItem.thick,
                      catalogItem.unit,
                      unit
                    );

                    const sizeValue =
                      convertedLen == 0 && convertedWid == 0 && convertedThick == 0
                        ? ''
                        : `${convertedLen} x ${convertedWid} x ${convertedThick} ${unit}`;
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Raleway',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: `${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'Raleway',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }

                  // if (
                  //   'unit' in catalogItem &&
                  //   'len' in catalogItem &&
                  //   'wid' in catalogItem &&
                  //   'thick' in catalogItem
                  // ) {
                  //   sizeValue = `${catalogItem.len}x${catalogItem.wid}x${catalogItem.thick} ${catalogItem.unit}`;
                  // }
                  // Add the combined size row if a valid sizeValue is available
                  // if (sizeValue) {
                  //   const sizeAttrCell = {
                  //     text: `${label[0]?.attributes.Sizeunit}`,
                  //     options: {
                  //       fontSize: 10,
                  //       fontFace: 'Raleway',
                  //       color: '#000000',
                  //       fill: '#afafaf',
                  //       border: { pt: 2, color: '#ffffff' },
                  //       valign: 'middle'
                  //     }
                  //   };
                  //   const sizeValCell = {
                  //     text: ` ${sizeValue}`,
                  //     options: {
                  //       fontSize: 8,
                  //       fontFace: 'Raleway',
                  //       color: '#000000',
                  //       fill: '#E5E4E2',
                  //       border: { pt: 2, color: '#ffffff' },
                  //       valign: 'middle'
                  //     }
                  //   };
                  //   tableRows.push([
                  //     sizeAttrCell,
                  //     { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                  //   ]);
                  //   yOffset += 0.1;
                  // }
                })();
          }
          if (selectedItems.includes('productMaterialName')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );
              // const matName = allSize.map(item => item.MatName || '').join('/');
              const matName = allSize
                .map(item => item.MatName) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const MaterialNameAttrCell = {
                text: `${label[0]?.attributes.MaterialName}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const MaterialNameValCell = {
                text: `${matName}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                MaterialNameAttrCell,
                { ...MaterialNameValCell, options: { ...MaterialNameValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productfinish')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              // const finishValues = allSize.map(item => item.FinishCode || '').join('/');
              const finishValues = allSize
                .map(item => {
                  const matchedFinish = finish.data.find(
                    finish => finish.attributes.FinishCode === item.FinishCode
                  );
                  return matchedFinish ? matchedFinish.attributes.FinishName : null;
                })
                .filter(value => value !== null) // Remove null values
                .join(' / ');

              // Join with "/"

              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: `${finishValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: ` ${catalogItem.finish}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productsalepri')) {
            // let price = '';
            // if ('currency' in catalogItem && 'saleprice' in catalogItem) {
            //   price =
            //     catalogItem.saleprice === 0 ? '' : `${catalogItem.saleprice} ${catalogItem.currency}`;
            // }
            // let allSize;
            // if (product.attributes.SetStatus === 'Set') {
            //   allSize = catalogueCatProductSize.filter(
            //     item => item.CatalogueProduct === catalogItem.CatalogProduct
            //   );
            //   console.log('allSize', allSize);
            //   // return ;
            //   price = allSize
            //     .map(item => item.Rate) // Extract NetWt values
            //     .filter(value => value !== null && value !== '') // Remove null or empty values
            //     .join('/'); //
            // }
            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;
            const sizeAttrCell = {
              text: 'Price',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: formattedPrice,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              const NetWtValues = allSize
                .map(item => (item.NetWt == 0 ? '' : `${item.NetWt} Kg`)) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: `${NetWtValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: catalogItem.netwgt === 0 ? '' : `${catalogItem.netwgt} Kg`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: catalogItem.cbm === 0 ? '' : `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productInnerAndMaster')) {
            let innerData = product.attributes.Packaging.filter(
              item => item.CartonType === 'inner'
            );
            let masterData = product.attributes.Packaging.filter(
              item => item.CartonType === 'master'
            );
            let innerValue =
              innerData.length <= 0
                ? 0
                : innerData.length === 1
                ? innerData[0].Carton_PCS
                : innerData.reduce((sum, item) => sum + item.Carton_PCS, 0);
            let masterValue =
              masterData.length <= 0 ? 0 : masterData.length === 1 ? masterData[0].Carton_PCS : 1;
            const sizeAttrCell = {
              text: 'Inner/Master',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: `${innerValue} / ${masterValue}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productMoq')) {
            const sizeAttrCell = {
              text: `${label[0]?.attributes.MOQ}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: product.attributes.MOQ == '0' ? '' : `${product.attributes.MOQ} Pcs`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('ptech')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.P_Technique}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${product?.attributes?.P_Technique}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('madeby')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.MadeBy}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${product?.attributes?.MadeBy}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: 5.5,
        y: 0.9,
        // w: '40%', // Adjust the width of the table as needed
        colW: [1.6, 2.7],
        fontSize: 6, // Adjust the font size as needed
        fontFace: 'Arial' // Set the font face
        // autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      if (tableRows.length > 0) {
        slide.addTable(tableRows, tableOptions);
      }
      // slide.addText(
      //   [
      //     {
      //       text: serialNumber,
      //       options: {
      //         fontSize: 10,
      //         fontFace: 'Arial',
      //         color: '#ffffff',
      //         align: 'left', // Align the serial number text to the left
      //         valign: 'middle' // Align the text vertically to the middle
      //       }
      //     }
      //   ],
      //   { x: 0.5, y: 0.65 } // Adjust the position as needed
      // );
    };
    // const reversedCata = [...cata];
    // let serialCounter = 1;
    // setLoadPPT(true);
    // // Loop through each item in cata and add a slide for each product
    // // reversedCata.forEach(item => {
    // //   addProductSlide(item, serialCounter, cataloguecatappt);
    // //   serialCounter++;
    // // });
    // for (let item of reversedCata) {
    //   await addProductSlide(item, serialCounter, cataloguecatappt);
    //   serialCounter++; // Ensure to await each slide creation
    // }
    // // Download the PPT file
    // ppt
    //   .writeFile({ fileName: `${cataName} PPt.pptx` })
    //   .then(res => {
    //     setLoadPPT(false);
    //     setOpenAttri(false);
    //   })
    //   .catch(err => console.log(err));
    // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

    setLoadPPT(true);

    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt, catah, catahb); // Pass ppt is not needed
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    } else {
      // If `cata` is a multidimensional array (e.g., array of catalogues)
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        // const headerimg = catappt[0]?.attributes?.HPath;
        // const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (catacover === 'Yes' || catacoverb === 'Yes') {
          await addIntroductionSlide(ppt); // Pass ppt is not needed
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt, catah, catahb); // Pass ppt is not needed
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        await ppt.writeFile({ fileName });

        catalogueIndex++;
      }
    }

    setLoadPPT(false);
    setOpen(false);
    setOpenAttri(false);
  };
const handleDownloadPPT5 = async (
  data2,
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName
) => {
  // console.log('handleDownloadPPT5');

  const ppt = new pptxgen();

  const getImageSize = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = err => {
        reject(err);
      };
      img.src = imageUrl;
    });
  };
  const addHeaderToSlide = (slide, headerText = 'Header Content') => {
    // Add a rectangle (box)
    const rectWidth = 9; // Adjust width as needed
    const rectHeight = 0.6; // Adjust height as needed
    slide.addShape('rect', {
      x: 0.5,
      y: 0.2,
      w: rectWidth,
      h: rectHeight,
      fill: '#000000',
      line: { color: '#ffffff', width: 0.01 }
    });

    // Add text inside the box
    slide.addText(headerText, {
      x: 0.6,
      y: 0.25,
      w: rectWidth - 0.2, // Adjust width for text padding
      h: rectHeight - 0.1, // Adjust height for text padding
      color: '#ffffff',
      fontSize: 14,
      bold: true,
      align: 'center'
    });

    // Add the logo image if available
    const logoImageUrl = catappt[0]?.attributes?.HPath?.data?.attributes?.url;
    const img = `${ip}${logoImageUrl}` || garment1;

    if (img) {
      const logoOptions = {
        x: 0.5, // Adjust x to center logo within the rectangle
        y: 0.2, // Align logo with the top of the rectangle
        w: rectWidth, // Take the full width of the rectangle
        h: rectHeight // Take the full height of the rectangle
      };
      slide.addImage({ path: img, ...logoOptions });
    }
  };
  // Helper function to add a slide with the product image and attributes
  const addProductSlide = async (product, ppt) => {
    const slide = ppt.addSlide();
    addHeaderToSlide(slide, 'Introduction');
    const backgroundColor = {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      fill: '#f4f6f5'
    };
    slide.addShape('rect', backgroundColor);

    const firstItem = data2.length > 0 ? data2[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
        }
      ],
      { x: 1.4, y: 0.5, align: 'center' }
    );

    const logoImageUrl = firstItem?.attributes?.Logo?.data?.attributes?.url || '';
    // Add the logo image if the URL is available
    if (logoImageUrl) {
      const logoOptions = {
        x: 1,
        y: 0.4,
        w: 1,
        h: 0.2
      };
      const logoFullPath = `${ip}${logoImageUrl}`;
      slide.addImage({ path: logoFullPath, ...logoOptions });
    }

    // Add the product image from the nested "CoverImage" attribute
    const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
    // console.log('imageUrl--->', imageUrl);

    try {
      // Wait for the image to load and get its size
      const { width, height } = await getImageSize(imageUrl);
      let image = imageUrl;
      if (watermark) {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        image = imageUrl2;
      }
      // Define the maximum width and height for the image on the slide (adjust these values as needed)
      const maxWidth = 4.3; // Maximum width in inches
      const maxHeight = 3.4; // Maximum height in inches

      // Calculate the aspect ratio
      const aspectRatio = width / height;

      // Scale the image to fit within the slide's boundaries
      let imageWidth = width;
      let imageHeight = height;

      // Check if the image exceeds the max dimensions and scale it down
      if (width > maxWidth || height > maxHeight) {
        if (aspectRatio > 1) {
          // Scale by width if the image is wider than tall
          imageWidth = maxWidth;
          imageHeight = maxWidth / aspectRatio;
        } else {
          // Scale by height if the image is taller than wide
          imageHeight = maxHeight;
          imageWidth = maxHeight * aspectRatio;
        }
      }

      // Ensure the image is constrained within the slide's width and height
      if (imageWidth > maxWidth) imageWidth = maxWidth;
      if (imageHeight > maxHeight) imageHeight = maxHeight;

      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: imageWidth, // Use scaled width
        h: imageHeight // Use scaled height
      };

      slide.addImage({ path: image, ...imageOptions });
    } catch (err) {
      console.error('Error loading image:', err);
    }

    // Add product attributes to the slide as a table
    const tableRows = [];

    if ('ProductId' in product.attributes) {
      const productIdAttrCell = {
        text: 'Alias Code',
        options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
      };
      const productIdValCell = {
        text: `: ${product.attributes.ProductId?.toString() || ''}`,
        options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
      };
      const yOffset = 7;
      const productIdOptions = { ...productIdValCell.options, y: yOffset };
      tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
    }

    const tableOptions = {
      x: 0.5,
      y: 4.8,
      w: '20%',
      fontSize: 8,
      fontFace: 'Arial',
      autoPage: true
    };

    slide.addTable(tableRows, tableOptions);
  };

  // for (let item of cata) {
  //   await addProductSlide(item); // Ensure to await each slide creation
  // }

  // // Download the PPT file
  // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

  // setLoadPPT(true);

  let catalogueIndex = 1;

  // Check if `cata` is a flat array (not a multidimensional array)
  if (Array.isArray(cata) && !Array.isArray(cata[0])) {
    // If `cata` is a flat array, process all products directly
    const ppt = new pptxgen();

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // const headerimg = catappt[0]?.attributes?.HPath;
    // const headerimgb = buyercata[0]?.attributes?.HPath;
    // const catah = catappt[0]?.attributes?.Header;
    // const catahb = buyercata[0]?.attributes?.Header;

    // Add introduction slide if needed
    // if (catacover === 'Yes' || catacoverb === 'Yes' ) {
    //   await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
    // }

    let serialCounter = 1;
    for (let product of cata) {
      // Ensure product is valid before adding slide
      if (product) {
        await addProductSlide(product, ppt); // Pass ppt is not needed
        serialCounter++;
      } else {
        console.warn('Skipping invalid product:', product);
      }
    }

    // Generate the final PowerPoint file
    const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
    await ppt.writeFile({ fileName });

    catalogueIndex++;
  } else {
    // If `cata` is a multidimensional array (e.g., array of catalogues)
    for (let catalogue of cata) {
      const ppt = new pptxgen();

      // const catacover = catappt[0]?.attributes?.CoverSlide;
      // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // // const headerimg = catappt[0]?.attributes?.HPath;
      // // const headerimgb = buyercata[0]?.attributes?.HPath;
      // // const catah = catappt[0]?.attributes?.Header;
      // // const catahb = buyercata[0]?.attributes?.Header;

      // if (catacover === 'Yes' || catacoverb === 'Yes') {
      //   await addIntroductionSlide(ppt); // Pass ppt is not needed
      // }

      let serialCounter = 1;
      for (let product of catalogue) {
        await addProductSlide(product, ppt); // Pass ppt is not needed
        serialCounter++;
      }

      const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    }
  }
};
const handleDownloadPPT6 = async (
  cata,
  buyername,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  sizeshow,
  unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm
  {
    // console.log('handleDownloadPPT6');

    // const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };
    const addHeaderToSlide = (slide, headerText = 'Header Content') => {
      // Add a rectangle (box)
      const rectWidth = 9; // Adjust width as needed
      const rectHeight = 0.6; // Adjust height as needed
      slide.addShape('rect', {
        x: 0.5,
        y: 0.2,
        w: rectWidth,
        h: rectHeight,
        fill: '#000000',
        line: { color: '#ffffff', width: 0.01 }
      });

      // Add text inside the box
      slide.addText(headerText, {
        x: 0.6,
        y: 0.25,
        w: rectWidth - 0.2, // Adjust width for text padding
        h: rectHeight - 0.1, // Adjust height for text padding
        color: '#ffffff',
        fontSize: 14,
        bold: true,
        align: 'center'
      });

      // Add the logo image if available
      const logoImageUrl = catappt[0]?.attributes?.HPath?.data?.attributes?.url;
      const img = `${ip}${logoImageUrl}` || garment1;

      if (img) {
        const logoOptions = {
          x: 0.5, // Adjust x to center logo within the rectangle
          y: 0.2, // Align logo with the top of the rectangle
          w: rectWidth, // Take the full width of the rectangle
          h: rectHeight // Take the full height of the rectangle
        };
        slide.addImage({ path: img, ...logoOptions });
      }
    };

    const addIntroductionSlide = async ppt => {
      const slide = ppt.addSlide();
      addHeaderToSlide(slide, 'Introduction');
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const image =
        buyername &&
        buyercata?.length > 0 &&
        buyercata[0]?.attributes?.CSPath?.data?.attributes?.url
          ? buyercata[0].attributes.CSPath.data.attributes.url
          : catappt?.[0]?.attributes?.CSPath?.data?.attributes?.url;

      const logoImageUrl = image;
      const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (img) {
        const logoOptions = {
          x: 0, // Adjust the x-coordinate of the logo
          y: 0, // Adjust the y-coordinate of the logo
          w: '100%', // Adjust the width of the logo
          h: '100%' // Adjust the height of the logo
        };

        slide.addImage({ path: img, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      // slide.addText(
      //   [
      //     { text: companyName, options: { fontSize: 20, fontFace: 'Raleway', color: '#303030' } },
      //   ],
      //   { x: 0. - 1, y: 2.5, align: 'center' }
      // );
      // slide.addText(address, { x: 0. - 1, y: 3, fontSize: 14, fontFace: 'Raleway', color: '#303030', align: 'center' });
      // Add more text or content as desired
    };

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }
    const addProductSlide = async (product, serialNumber, catalgoue, ppt) => {
      const slide = ppt.addSlide();
      addHeaderToSlide(slide, 'Introduction');
      const backgroundColor = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: '100%', // Height spans the entire slide
        fill: '#f4f6f5' // Replace 'yourColorCode' with your desired background color
      };
      slide.addShape('rect', backgroundColor);
      const squareColor = {
        x: 0, // X-coordinate for the square
        y: 0, // Y-coordinate for the square
        w: 0.5, // Width of the square
        h: 0.5, // Height of the square
        fill: '#ddd0bd' // Replace 'yourSquareColor' with your desired square color
      };
      slide.addShape('rect', squareColor);
      // Add the product attributes as a table
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value
      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productAlias')) {
            const pnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const pnameValCell = {
              text: `${catalogItem.productname}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              pnameAttrCell,
              { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `${label[0]?.attributes.SizeRange}`,
                    options: {
                      fontSize: 10,
                      fontFace: 'Times New Roman',
                      color: '#000000',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'Times New Roman',
                      color: '#000000',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  const convertedLen = convertDimension(catalogItem.len, catalogItem.unit, unit);

                  const convertedWid = convertDimension(catalogItem.wid, catalogItem.unit, unit);

                  const convertedThick = convertDimension(
                    catalogItem.thick,
                    catalogItem.unit,
                    unit
                  );

                  let sizeValue =
                    convertedLen == 0 && convertedWid == 0 && convertedThick == 0
                      ? ''
                      : `${convertedLen} x ${convertedWid} x ${convertedThick} ${unit}`;

                  // Add the combined size row if a valid sizeValue is available
                  if (sizeValue) {
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Times New Roman',
                        color: '#000000',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: ` ${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'Times New Roman',
                        color: '#000000',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }

          if (selectedItems.includes('productfinish')) {
            const finisheAttrCell = {
              text: `${label[0]?.attributes.finish}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const finidhValCell = {
              text: ` ${catalogItem.finish}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              finisheAttrCell,
              { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsalepri')) {
            // let price = '';
            // if ('currency' in catalogItem && 'saleprice' in catalogItem) {
            //   price = `${catalogItem.currency} ${catalogItem.saleprice}`;
            // }

            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;
            if (price) {
              const sizeAttrCell = {
                text: 'Price',
                options: {
                  fontSize: 10,
                  fontFace: 'Times New Roman',
                  color: '#000000',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const sizeValCell = {
                text: ` ${formattedPrice}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Times New Roman',
                  color: '#000000',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                sizeAttrCell,
                { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productntw')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.NetWgt}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: ` ${catalogItem.netwgt}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'Times New Roman',
                color: '#000000',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: 0.8,
        y: 1,
        w: '30%', // Adjust the width of the table as needed
        fontSize: 8, // Adjust the font size as needed
        fontFace: 'Arial', // Set the font face
        autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
      // Add the product image from the nested "CoverImage" attribute
      // const imageUrl = `${ip}${product.attributes.CoverImage.data.attributes.url}`;
      // const imageOptions = {
      //   x: 5.4,
      //   y: 0.7,
      //   w: 4, // Adjust the width of the image as needed
      //   h: 4 // Adjust the height of the image as needed
      // };
      // slide.addImage({ path: imageUrl, ...imageOptions });
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

      const containerX = 4.2; // X-coordinate of the container
      const containerY = 0.7; // Y-coordinate of the container
      const containerWidth = 5; // Maximum container width
      const containerHeight = 4.4; // Maximum container height

      try {
        // Wait for the image to load and get its size
        const { width, height } = await getImageSize(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }
        // Calculate the aspect ratio
        const aspectRatio = width / height;

        // Scale the image to fit within the container
        let imageWidth = width;
        let imageHeight = height;

        if (aspectRatio > 1) {
          // Landscape image: Scale based on container width
          imageWidth = Math.min(containerWidth, width);
          imageHeight = imageWidth / aspectRatio;
        } else {
          // Portrait or square image: Scale based on container height
          imageHeight = Math.min(containerHeight, height);
          imageWidth = imageHeight * aspectRatio;
        }

        // Center the image within the container
        const imageX = containerX + (containerWidth - imageWidth) / 2;
        const imageY = containerY + (containerHeight - imageHeight) / 2;

        // Add a background rectangle for the image container
        slide.addShape('rect', {
          x: containerX,
          y: containerY,
          w: containerWidth,
          h: containerHeight
          // fill: '#eaeaea' // Light gray for the container background
        });

        // Add the image to the slide
        slide.addImage({ path: image, x: imageX, y: imageY, w: imageWidth, h: imageHeight });
      } catch (err) {
        console.error('Error loading image:', err);
      }

      slide.addText(
        [
          {
            text: serialNumber,
            options: {
              fontSize: 12,
              fontFace: 'Arial',
              color: '#000000',
              align: 'left', // Align the serial number text to the left
              valign: 'middle' // Align the text vertically to the middle
            }
          }
        ],
        { x: 0.5, y: 5.3 } // Adjust the position as needed
      );
    };
    let serialCounter = 1;
    // setLoadPPT(true);
    // // Loop through each item in cata and add a slide for each product
    // // reversedCata.forEach(item => {
    // //   addProductSlide(item, serialCounter, cataloguecatappt);
    // //   // serialCounter++;
    // // });

    // // let serialCounter = 1;
    // // const reversedCata = [...cata].reverse();
    // for (let item of cata) {
    //   await addProductSlide(item, serialCounter, cataloguecatappt);
    //   serialCounter++; // Ensure to await each slide creation
    // }
    // // Download the PPT file
    // ppt
    //   .writeFile({ fileName: `${cataName} PPt.pptx` })
    //   .then(res => {
    //     setLoadPPT(false);
    //     setOpenAttri(false);
    //   })
    //   .catch(err => console.log(err));
    // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

    setLoadPPT(true);

    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    } else {
      // If `cata` is a multidimensional array (e.g., array of catalogues)
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        // const headerimg = catappt[0]?.attributes?.HPath;
        // const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (catacover === 'Yes' || catacoverb === 'Yes') {
          await addIntroductionSlide(ppt); // Pass ppt is not needed
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, ppt); // Pass ppt is not needed
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        await ppt.writeFile({ fileName });

        catalogueIndex++;
      }
    }
    setLoadPPT(false);
    setOpen(false);
    setOpenAttri(false);
  };
const handleDownloadPPT11 = async (
  cata,
  data2,
  catalogueCatProductSize,
  colordata,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataloguecatappt,
  label,
  setLoadPPT,
  buyercata = [],
  catappt = [],
  selectedUnit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT11');

  // Fetch the CoverSlide status and image path if applicable
  const getBannerImage = async () => {
    try {
      const coverSlideResponse = await fetch(`${ip}/api/temp-libs/1`);
      const coverSlideData = await coverSlideResponse.json();
      const coverSlide = coverSlideData.data.attributes.CoverSlide;

      if (coverSlide === 'Yes') {
        const imageResponse = await fetch(
          `${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`
        );
        const imageData = await imageResponse.json();
        const bannerImagePath = imageData.data[0]?.attributes?.CSPath?.data?.attributes?.url;

        return bannerImagePath ? `${ip}${bannerImagePath}` : null; // Return null if no image found
      }

      return null; // Return null if no cover slide is present
    } catch (error) {
      console.error('Error fetching banner image:', error);
      return null; // Return null if an error occurs
    }
  };

  const addIntroductionSlide = async () => {
    const slide = ppt.addSlide();
    const bannerImage = await getBannerImage();

    if (bannerImage) {
      slide.addImage({
        path: bannerImage,
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      });
    }
  };

  // console.log('Format working...');
  const fetchImageDimensions = url =>
    new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.src = url;
    });

  const isValidImage = async url => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok; // If the image exists, it will return a status code of 200
    } catch (error) {
      return false; // Image is invalid or unavailable
    }
  };

  const addProductSlide = async (product, catalgoue) => {
    // console.log('Inside Product data ', product);
    // console.log('Inside cata data ', catalgoue);
    const slide = ppt.addSlide();

    // Add top and bottom red strips
    slide.addShape('rect', {
      x: '2.5%',
      y: '1%',
      w: '95%',
      h: 0.4,
      fill: { color: '#ab3011' }
    });

    slide.addShape('rect', {
      x: 0,
      y: '95%',
      w: '100%',
      h: 0.4,
      fill: { color: '#ab3011' }
    });

    slide.addText(`Vendor:- ${data2[0]?.attributes.cmpnm}`, {
      x: 0,
      y: 0.05,
      w: '100%',
      h: 0.4,
      fontSize: 24,
      fontFace: 'Algerian',
      color: '#FFFFFF',
      align: 'center',
      bold: true
    });

    // Set up image container dimensions
    const containerWidth = 3 * 1.9; // Increase width by 40%
    const containerHeight = 4.2; // Maximum height
    const containerTopMargin = 0.6; // 20% margin at the top
    const containerX = 6.5 - (containerWidth - 3); // Adjust X to shift left, subtract the increase in width
    const containerY = 0.12 + containerTopMargin; // Y position of the container

    // Add red background for the image container
    slide.addShape('rect', {
      x: containerX,
      y: containerY,
      w: containerWidth,
      h: containerHeight
      // fill: { color: '#FF0000' }, // Red background color
    });

    // Adjust the image dimensions dynamically
    const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
    const imageValid = await isValidImage(imageUrl);
    if (imageValid) {
      const { width, height } = await fetchImageDimensions(imageUrl);
      // console.log("Product PPT data :",product)
      let image = imageUrl;
      if (watermark) {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        image = imageUrl2;
      }
      const widthScale = containerWidth / width;
      const heightScale = containerHeight / height;
      const scale = Math.min(widthScale, heightScale);

      const scaledWidth = width * scale;
      const scaledHeight = height * scale;

      // Calculate the image position to center it in the container
      const xOffset = containerX + (containerWidth - scaledWidth) / 2; // Center horizontally
      const yOffset = containerY + (containerHeight - scaledHeight) / 2; // Center vertically within the container

      // Add the image
      slide.addImage({
        path: image,
        x: xOffset,
        y: yOffset,
        w: scaledWidth,
        h: scaledHeight
      });
    }

    // Add product details
    // const { Length, Width, Height, SizeUnit, ColorName, SetStatus, SetSizes, ProductId } = product.attributes;
    if (product.attributes.SetStatus !== 'Set') {
      const { len, wid, thick, unit, color } = catalgoue;
      const convertedLen = convertDimension(len, unit, selectedUnit);

      const convertedWid = convertDimension(wid, unit, selectedUnit);

      const convertedThick = convertDimension(thick, unit, selectedUnit);

      const sizeValue =
        convertedLen == 0 && convertedWid == 0 && convertedThick == 0
          ? ''
          : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
      // console.log('catalogue', catalgoue);
      // console.log('product.attributes.ProductName', product.attributes.ProductName);
      // console.log('${len}x${wid}x${thick} ${unit}', `${len}x${wid}x${thick} ${unit}`);

      const details = [
        {
          label: `${label[0].attributes.AliasCode}   : `,
          value: product.attributes.ProductId || ''
        },
        {
          label: 'Size          : ',
          value: sizeValue
        },
        {
          label: `${label[0].attributes.color}        : `,
          value: color && color !== 'null' ? color : ''
        }
      ];

      details.forEach((detail, index) => {
        slide.addText(`${detail.label} ${detail.value}`, {
          x: 0.1,
          y: 4 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
      });
    } else {
      const details = [
        {
          label: `${label[0].attributes.AliasCode}   : `,
          value: product.attributes.ProductId || ''
        },
        { label: 'Size          : ', value: '' }
      ];
      let i = 0;
      details.forEach((dim, index) => {
        slide.addText(`${dim.label}${dim.value}`, {
          x: 0.1,
          y: 3.5 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
      });
      let yDis = 3.5;

      const dimensions = catalogueCatProductSize
        .filter(item => item.CatalogueProduct === catalgoue.CatalogProduct)
        .map(size => ({
          value: `${
            size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
          } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
        }));

      // console.log('dimensions SIZE :', dimensions);

      dimensions.forEach((dim, index) => {
        if (i > 3) return;
        slide.addText(`${dim.value}`, {
          x: 1,
          y: 3.8 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
        yDis += 0.3;
        i++;
      });
      // Fetch all color from colorMaster
      let allColorData = [];
      let page = 1;

      while (true) {
        const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
        const result = await response.json();

        if (result.data) {
          allColorData = allColorData.concat(result.data);
        }

        if (page >= result.meta.pagination.pageCount) break;

        page++;
      }

      const dimensionsColor = catalogueCatProductSize
        .filter(size => size.CatalogueProduct == catalgoue.CatalogProduct) // Filter by CatalogueProduct ID
        .map(size => {
          // Find the matching color name for the given color code
          const color = colordata.find(c => c?.attributes?.ColorCode == size?.ColorCode);
          // console.log("color dataaaaa", allColorData)
          // console.log("colorrrrrr", color)
          return {
            value: color ? color?.attributes?.ColorName : size?.ColorCode // Use color name if found, else fallback to color code
          };
        });
      let finalColor = dimensionsColor
        .filter(item => item.value != '')
        .map(item => item.value)
        .join(' / ');
      if (finalColor == ' / ') {
        finalColor = '';
      }
      // console.log('dimensionsColor');
      // console.log(dimensionsColor);
      // console.log('finalColor');
      // console.log(finalColor);
      slide.addText(`${label[0].attributes.color}        : ${finalColor ?? ''}`, {
        x: 0.1,
        y: yDis + 0.3,
        fontSize: 12,
        fontFace: 'Arial',
        color: '#000000'
      });
    }
  };

  const bannerImage = await getBannerImage();
  if (bannerImage) {
    await addIntroductionSlide();
  }
  let serialCounter = 0;
  setLoadPPT(true);
  for (let item of cataloguecatappt.sort((a, b) => {
    return b.CatalogProduct - a.CatalogProduct;
  })) {
    const product = cata.find(pro => pro.id === Number(item.CatalogProduct));
    await addProductSlide(product, item);
    // serialCounter++; // Ensure to await each slide creation
  }
  // console.log('ppt13--->', ppt);
  // ppt.writeFile({ fileName: 'ppt' });
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  ppt
    .writeFile({ fileName: 'ppt.pptx' })
    .then(() => console.log('PPT file generated and downloaded'))
    .catch(err => console.error('Error downloading PPT file:', err));
};
const handleDownloadPPT13 = async (
  cata,
  data2,
  colordata,
  catalogueCatProductSize,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataloguecatappt,
  label,
  buyercata = [],
  catappt = [],
  selectedUnit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  // console.log('handleDownloadPPT13');

  const ppt = new pptxgen();

  // Fetch the CoverSlide status and image path if applicable
  const getBannerImage = async () => {
    try {
      // Fetch the first API to check if CoverSlide is 'yes'
      const coverSlideResponse = await fetch(`${ip}/api/temp-libs/1`);
      const coverSlideData = await coverSlideResponse.json();
      const coverSlide = coverSlideData.data.attributes.CoverSlide;

      if (coverSlide === 'Yes') {
        // Fetch the second API to get the image path if CoverSlide is 'yes'
        const imageResponse = await fetch(
          `${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`
        );
        const imageData = await imageResponse.json();
        const bannerImagePath = imageData.data[0]?.attributes?.CSPath?.data?.attributes?.url;
        return bannerImagePath ? `${ip}${bannerImagePath}` : null; // Return image URL if available
      }
      return null; // Return null if CoverSlide is not 'yes'
    } catch (error) {
      return null; // Return null in case of error
    }
  };

  // Helper function to add the first introduction slide with banner image
  const addIntroductionSlide = async () => {
    const slide = ppt.addSlide();
    const bannerImage = await getBannerImage(); // Get the banner image if applicable

    // If banner image is available, add it as the background
    if (bannerImage) {
      slide.addImage({
        path: bannerImage,
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      });
    }
  };

  // Fetch the banner image and add the introduction slide if necessary
  const bannerImage = await getBannerImage();
  if (bannerImage) {
    await addIntroductionSlide(); // Only add the first slide if banner image is available
  }

  // Helper function to scale the image proportionally
  const scaleImage = (imageUrl, maxWidth, maxHeight) => {
    const img = new Image();
    img.src = imageUrl;

    return new Promise(resolve => {
      img.onload = () => {
        // Calculate aspect ratio
        const aspectRatio = img.width / img.height;

        let width = maxWidth;
        let height = maxHeight;

        // Scale based on aspect ratio
        if (img.width > img.height) {
          // Landscape image
          height = maxWidth / aspectRatio;
          if (height > maxHeight) {
            height = maxHeight;
            width = maxHeight * aspectRatio;
          }
        } else {
          // Portrait image or square
          width = maxHeight * aspectRatio;
          if (width > maxWidth) {
            width = maxWidth;
            height = maxWidth / aspectRatio;
          }
        }

        resolve({ width, height });
      };
    });
  };
  const isValidImage = async url => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok; // If the image exists, it will return a status code of 200
    } catch (error) {
      return false; // Image is invalid or unavailable
    }
  };
  // Helper function to add slides with two products (red header and footer format)
  const addProductSlide = async (productLeft, cataLeft, productRight, cataRight) => {
    const slide = ppt.addSlide();

    // --- Add Red Header and Footer ---
    slide.addShape('rect', {
      x: '2.5%',
      y: '1%',
      w: '95%',
      h: 0.4,
      fill: { color: '#ab3011' }
    });
    slide.addShape('rect', {
      x: 0,
      y: '95%',
      w: '100%',
      h: 0.4,
      fill: { color: '#ab3011' }
    });

    // --- Vendor Name (Centered in Header) ---
    slide.addText(`Vendor:- ${data2[0].attributes.cmpnm}`, {
      x: 0,
      y: 0.05,
      w: '100%',
      h: 0.4,
      fontSize: 24,
      fontFace: 'Algerian',
      color: '#FFFFFF',
      align: 'center',
      bold: true
    });

    if (productLeft) {
      if (productLeft.attributes.SetStatus === 'Set') {
        const imageUrl = `${ip}${productLeft?.attributes?.CoverImage?.data?.attributes?.url}`;

        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          if (imageUrl) {
            // Scale the image based on the defined max width and height
            const { width, height } = await scaleImage(imageUrl, 2.7, 3); // Scaling
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            // Add background color container for the left image (Red)
            slide.addShape('rect', {
              x: 0.5, // Left alignment
              y: '12%',
              w: width + 0.2, // Slight padding around image
              h: height + 0.2 // Slight padding around image
            });

            // Add the image on top of the container
            slide.addImage({
              path: image,
              x: 0.5, // Left alignment
              y: '12%',
              w: width,
              h: height
            });
          }
        }
        // Product details
        const detailsLeft = [
          {
            label: `${label[0].attributes.AliasCode} : `,
            value: productLeft.attributes.ProductId || ''
          },
          { label: 'Size             : ', value: '' }
        ];

        detailsLeft.forEach((dim, index) => {
          slide.addText(`${dim.label}${dim.value}`, {
            x: 0.3,
            y: 3.8 + index * 0.3,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
        });
        let yDis = 4.1;
        let i = 0;
        // const productSizes = cataResponse.data.attributes.ProductSizes;
        // console.log("SET SET SET :", productSizes)
        const dimensions = catalogueCatProductSize
          .filter(item => item.CatalogueProduct === cataLeft.CatalogProduct)
          .map(size => ({
            value: `${
              size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
            } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
          }));
        dimensions.forEach((dim, index) => {
          if (i > 3) return;
          slide.addText(`${dim.value}`, {
            x: 1.2,
            y: 4.1 + index * 0.2,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
          yDis += 0.2;
        });
        let allColorData = [];
        let page = 1;

        while (true) {
          const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
          const result = await response.json();

          if (result.data) {
            allColorData = allColorData.concat(result.data);
          }

          if (page >= result.meta.pagination.pageCount) break;

          page++;
        }

        const dimensionsColor = catalogueCatProductSize
          .filter(size => size.CatalogueProduct == cataLeft.CatalogProduct) // Filter by CatalogueProduct ID
          .map(size => {
            // Find the matching color name for the given color code
            const color = colordata.find(c => c?.attributes?.ColorCode == size?.ColorCode);
            return {
              value: color ? color?.attributes?.ColorName : size?.ColorCode // Use color name if found, else fallback to color code
            };
          });
        let finalColor = dimensionsColor
          .filter(item => item.value != '')
          .map(item => item.value)
          .join(' / ');
        if (finalColor == ' / ') {
          finalColor = '';
        }
        slide.addText(`${label[0].attributes.color}         : ${finalColor ?? ''}`, {
          x: 0.3,
          y: yDis + 0.1,
          fontSize: 11,
          fontFace: 'Algerian',
          color: '#000000'
        });
      } else {
        // Handle non-Set products (not part of a set)
        const imageUrl = `${ip}${productLeft?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          if (imageUrl) {
            // Scale the image based on the defined max width and height
            const { width, height } = await scaleImage(imageUrl, 2.7, 3); // Scaling
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            slide.addImage({
              path: image,
              x: 0.5, // Left alignment
              y: '12%',
              w: width,
              h: height
            });
          }
        }
        const { len, wid, thick, unit, color } = cataLeft;
        const convertedLen = convertDimension(len, unit, selectedUnit);

        const convertedWid = convertDimension(wid, unit, selectedUnit);

        const convertedThick = convertDimension(thick, unit, selectedUnit);

        const sizeValue =
          convertedLen == 0 && convertedWid == 0 && convertedThick == 0
            ? ''
            : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
        const detailsLeft = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productLeft.attributes.ProductId || ''
          },
          {
            label: `Size :`,
            value: sizeValue || ''
          },
          {
            label: `${label[0].attributes.color} :`,
            value: color && color !== 'null' ? color : ''
          }
        ];

        detailsLeft.forEach((detail, index) => {
          slide.addText(`${detail.label} ${detail.value}`, {
            x: 0.5, // Left alignment
            y: 4 + index * 0.3, // Bottom-left positioning
            fontSize: 11,
            fontFace: 'Algerian', // Algerian font
            align: 'left',
            color: '#000000'
          });
        });
      }
    }
    if (productRight) {
      if (productRight.attributes.SetStatus === 'Set') {
        const imageUrl = `${ip}${productRight?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          if (imageUrl) {
            // Scale the image based on the defined max width and height
            const { width, height } = await scaleImage(imageUrl, 2.7, 3);
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            // Add background color container for the right image (Red)
            slide.addShape('rect', {
              x: 6.5, // Right alignment
              y: '40%',
              w: width + 0.2, // Slight padding around image
              h: height + 0.2 // Slight padding around image
              // fill: { color: '#ff0000' }, // Red background color
              // line: { color: 'black', width: 1 }, // Optional border around the container
            });

            // Add the image on top of the container
            slide.addImage({
              path: image,
              x: 6.5, // Right alignment
              y: '40%',
              w: width,
              h: height
            });
          }
        }
        const detailsRight = [
          {
            label: `${label[0].attributes.AliasCode} : `,
            value: productRight.attributes.ProductId || ''
          },
          { label: 'Size             : ', value: '' }
        ];

        let i = 0;
        detailsRight.forEach((dim, index) => {
          slide.addText(`${dim.label}${dim.value}`, {
            x: 6.3,
            y: 0.8 + index * 0.3, // Top-right positioning
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
        });

        let yDis = 1.1; // Start just below the details

        const dimensions = catalogueCatProductSize
          .filter(item => item.CatalogueProduct === cataRight.CatalogProduct)
          .map(size => ({
            value: `${
              size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
            } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
          }));

        // console.log("Dimension For Set :", dimensions);
        dimensions.forEach((dim, index) => {
          if (i > 3) return;
          slide.addText(`${dim.value}`, {
            x: 7.2,
            y: 1.1 + index * 0.2,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
          yDis += 0.2;
          i++;
        });
        let allColorData = [];
        let page = 1;

        while (true) {
          const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
          const result = await response.json();

          if (result.data) {
            allColorData = allColorData.concat(result.data);
          }

          if (page >= result.meta.pagination.pageCount) break;

          page++;
        }

        const dimensionsColor = catalogueCatProductSize
          .filter(size => size.CatalogueProduct == cataRight.CatalogProduct) // Filter by CatalogueProduct ID
          .map(size => {
            // Find the matching color name for the given color code
            const color = colordata.find(c => c.attributes.ColorCode == size.ColorCode);
            return {
              value: color ? color.attributes.ColorName : size.ColorCode // Use color name if found, else fallback to color code
            };
          });
        let finalColor = dimensionsColor
          .filter(item => item.value != '' && item.value != 'null')
          .map(item => item.value)
          .join(' / ');
        if (finalColor == '/ ') {
          finalColor = '';
        }
        // Split finalColor into an array of individual color names
        const colorArray = finalColor.split(' / ');

        // Group the colors into chunks of 2
        let colorChunks = [];
        for (let i = 0; i < colorArray.length; i += 2) {
          colorChunks.push(colorArray.slice(i, i + 2).join(' / ')); // Join every two colors with " / "
        }

        // Add each chunk of colors to the slide

        let yPosition = yDis + 0.1;
        colorChunks.forEach((chunk, index) => {
          if (index == 0) {
            slide.addText(`${label[0].attributes.color}         : ${chunk}`, {
              x: 6.3,
              y: yPosition,
              fontSize: 11,
              fontFace: 'Algerian',
              color: '#000000'
            });
            yPosition += 0.3; // Adjust vertical spacing for each new line
          } else {
            slide.addText(
              `${printStringNTimes(' ', label[0].attributes.color.length)}         ${chunk}`,
              {
                x: 6.3,
                y: yPosition,
                fontSize: 11,
                fontFace: 'Algerian',
                color: '#000000'
              }
            );
            yPosition += 0.3; // Adjust vertical spacing for each new line
          }
        });
      } else {
        const imageUrl = `${ip}${productRight?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          // console.log("Right Product Image URL:", imageUrl);
          if (imageUrl) {
            const { width, height } = await scaleImage(imageUrl, 2.7, 3);
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            slide.addImage({
              path: image,
              x: 6.5, // Right alignment
              y: '40%',
              w: width, // Adjust width for 40% smaller size (60% of 4.5)
              h: height // Adjust height for 40% smaller size (60% of 5)
            });
          }
        }
        const { len, wid, thick, unit, color } = cataRight;
        const convertedLen = convertDimension(len, unit, selectedUnit);

        const convertedWid = convertDimension(wid, unit, selectedUnit);

        const convertedThick = convertDimension(thick, unit, selectedUnit);

        const sizeValue =
          convertedLen == 0 && convertedWid == 0 && convertedThick == 0
            ? ''
            : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
        // Right product details

        const detailsRight = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productRight.attributes.ProductId || ''
          },
          {
            label: `Size :`,
            value: sizeValue || ''
          },
          {
            label: `${label[0].attributes.color} :`,
            value: color && color !== 'null' ? color : ''
          }
        ];

        detailsRight.forEach((detail, index) => {
          slide.addText(`${detail.label} ${detail.value}`, {
            x: 6.5, // Right alignment
            y: 0.8 + index * 0.3, // Top-right positioning
            fontSize: 11,
            fontFace: 'Algerian', // Algerian font
            align: 'left',
            color: '#000000'
          });
        });
      }
    }
  };
  // console.log('cata', cata);
  // console.log('cataloguecatappt', cataloguecatappt);
  // return;
  for (let i = 0; i < cataloguecatappt.length; i += 2) {
    const productLeft = cata.find(pro => pro.id === Number(cataloguecatappt[i].CatalogProduct));

    const productRight = cata.find(
      pro => pro.id === Number(cataloguecatappt[i + 1]?.CatalogProduct)
    );

    await addProductSlide(
      productLeft,
      cataloguecatappt[i],
      productRight,
      cataloguecatappt[i + 1] ? cataloguecatappt[i + 1] : null
    );
  }
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  // Download the PPT file
  ppt.writeFile({ fileName: 'ppt' });
};
const handleDownloadPPT14 = async (
  cata,
  colordata,
  catalogueCatProductSize,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataloguecatappt,
  label,
  buyercata = [],
  catappt = [],
  selectedUnit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT14');

  // Fetch the CoverSlide status and image path if applicable
  const getBannerImage = async () => {
    try {
      const coverSlideResponse = await fetch(`${ip}/api/temp-libs/1`);
      const coverSlideData = await coverSlideResponse.json();
      const coverSlide = coverSlideData.data.attributes.CoverSlide;

      if (coverSlide === 'Yes') {
        const imageResponse = await fetch(
          `${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`
        );
        const imageData = await imageResponse.json();

        const bannerImagePath = imageData.data[0]?.attributes?.CSPath?.data?.attributes?.url;
        return bannerImagePath ? `${ip}${bannerImagePath}` : null;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  // Helper function to get image dimensions
  const getImageDimensions = async imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.onerror = reject;
      img.src = imageUrl;
    });
  };

  // Helper function to add images proportionally
  const addProportionalImage = async (
    slide,
    imageUrl,
    containerX,
    containerY,
    containerWidth,
    containerHeight
  ) => {
    try {
      const { width, height } = await getImageDimensions(imageUrl);
      const aspectRatio = width / height;
      let image = imageUrl;
      if (watermark) {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        image = imageUrl2;
      }
      // Set image width and height within the container's boundaries
      let imageWidth = containerWidth;
      let imageHeight = imageWidth / aspectRatio;

      // If image height exceeds container height, adjust width and height accordingly
      if (imageHeight > containerHeight) {
        imageHeight = containerHeight;
        imageWidth = imageHeight * aspectRatio;
      }

      // Add the image inside the container
      slide.addImage({
        path: image,
        x: containerX + (containerWidth - imageWidth) / 2, // Center the image horizontally inside the container
        y: containerY + (containerHeight - imageHeight) / 2, // Center the image vertically inside the container
        w: imageWidth,
        h: imageHeight
      });
    } catch (error) {
      console.error('Error fetching image dimensions:', error);
    }
  };
  const addIntroductionSlide = async () => {
    const slide = ppt.addSlide();
    const bannerImage = await getBannerImage();

    if (bannerImage) {
      slide.addImage({
        path: bannerImage,
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      });
    }
  };

  // Fetch the banner image and add the introduction slide if necessary
  const bannerImage = await getBannerImage();
  if (bannerImage) {
    await addIntroductionSlide(); // Only add the first slide if banner image is available
  }

  // Helper function to add product slides
  const addProductSlide = async (product, catalgoue) => {
    const slide = ppt.addSlide();
    slide.addShape('rect', {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      line: { color: '#1ec94c', width: 10 } // Optional outline for the border
    });
    // Define container dimensions and position
    const containerWidth = 3 * 1.9; // Increase width by 40%
    const containerHeight = 4.2; // Maximum height
    const containerTopMargin = 0.6; // 20% margin at the top
    const containerX = 6.5 - (containerWidth - 3); // Adjust X to shift left, subtract the increase in width
    const containerY = 0.12 + containerTopMargin; // Y position of the container

    // Add red background for the image container (optional)
    slide.addShape('rect', {
      x: containerX,
      y: containerY,
      w: containerWidth,
      h: containerHeight
      // fill: { color: '#FF0000' }, // Red background color (optional for debugging)
    });

    // Add product image to the container
    if (product) {
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      await addProportionalImage(
        slide,
        imageUrl,
        containerX,
        containerY,
        containerWidth,
        containerHeight
      ); // Add image inside the container
    }
    if (product.attributes.SetStatus !== 'Set') {
      const { len, wid, thick, unit, color } = catalgoue;
      const convertedLen = convertDimension(len, unit, selectedUnit);

      const convertedWid = convertDimension(wid, unit, selectedUnit);

      const convertedThick = convertDimension(thick, unit, selectedUnit);

      const sizeValue =
        convertedLen == 0 && convertedWid == 0 && convertedThick == 0
          ? ''
          : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
      const details = [
        {
          label: `${label[0].attributes.AliasCode}   : `,
          value: product.attributes.ProductId || ''
        },
        {
          label: 'Size          : ',
          value: sizeValue
        },
        {
          label: `${label[0].attributes.color}        : `,
          value: color && color !== 'null' ? color : ''
        }
      ];

      details.forEach((detail, index) => {
        slide.addText(`${detail.label} ${detail.value}`, {
          x: 0.1,
          y: 4 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
      });
    } else {
      const details = [
        {
          label: `${label[0].attributes.AliasCode}   : `,
          value: product.attributes.ProductId || ''
        },
        { label: 'Size          : ', value: '' }
      ];
      let i = 0;
      details.forEach((dim, index) => {
        slide.addText(`${dim.label}${dim.value}`, {
          x: 0.1,
          y: 3.5 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
      });
      let yDis = 3.8;
      // Filter and map the data to the required format
      const dimensions = catalogueCatProductSize
        .filter(item => item.CatalogueProduct === catalgoue.CatalogProduct)
        .map(size => ({
          value: `${
            size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
          } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
        }));
      dimensions.forEach((dim, index) => {
        if (i > 3) return;
        slide.addText(`${dim.value}`, {
          x: 1,
          y: 3.8 + index * 0.3,
          fontSize: 12,
          fontFace: 'Arial',
          color: '#000000'
        });
        yDis += 0.3;
        i++;
      });

      // Fetch all color from colorMaster
      let allColorData = [];
      let page = 1;

      while (true) {
        const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
        const result = await response.json();

        if (result.data) {
          allColorData = allColorData.concat(result.data);
        }

        if (page >= result.meta.pagination.pageCount) break;

        page++;
      }

      const dimensionsColor = catalogueCatProductSize
        .filter(size => size.CatalogueProduct == catalgoue.CatalogProduct) // Filter by CatalogueProduct ID
        .map(size => {
          // Find the matching color name for the given color code
          const color = colordata.find(c => c?.attributes?.ColorCode == size?.ColorCode);
          return {
            value: color ? color?.attributes?.ColorName : size?.ColorCode // Use color name if found, else fallback to color code
          };
        });
      let finalColor = dimensionsColor
        .filter(item => item.value != '')
        .map(item => item.value)
        .join(' / ');
      if (finalColor == ' / ') {
        finalColor = '';
      }
      // console.log('dimensionsColor');
      // console.log(dimensionsColor);
      // console.log('finalColor');
      // console.log(finalColor);
      slide.addText(`${label[0].attributes.color}        : ${finalColor ?? ''}`, {
        x: 0.1,
        y: yDis + 0.3,
        fontSize: 12,
        fontFace: 'Arial',
        color: '#000000'
      });
      // console.log('h14141414');
    }
  };

  for (let item of cataloguecatappt) {
    const product = cata.find(pro => pro.id === Number(item.CatalogProduct));
    await addProductSlide(product, item);
  }
  // Download the PPT file
  // console.log('ppt14--->', ppt);
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  ppt.writeFile({ fileName: 'ppt' });
};
function printStringNTimes(str, n) {
  return new Array(n + 2).fill(str).join(' ');
}
const handleDownloadPPT12 = async (
  cata,
  colordata,
  catalogueCatProductSize,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataloguecatappt,
  label,
  buyercata = [],
  catappt = [],
  selectedUnit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  // console.log('handleDownloadPPT12');

  const ppt = new pptxgen();
  const getBannerImage = async () => {
    try {
      // Fetch the first API to check if CoverSlide is 'yes'
      const coverSlideResponse = await fetch(`${ip}/api/temp-libs/1`);
      const coverSlideData = await coverSlideResponse.json();
      const coverSlide = coverSlideData.data.attributes.CoverSlide;
      // console.log('CoverSlide data:', coverSlide);

      if (coverSlide === 'Yes') {
        // Fetch the second API to get the image path if CoverSlide is 'yes'
        const imageResponse = await fetch(
          `${ip}/api/temp-libs?populate=*&filters[Type][$eq]=Regular`
        );
        const imageData = await imageResponse.json();
        // console.log('Image data:', imageData);

        const bannerImagePath = imageData.data[0]?.attributes?.CSPath?.data?.attributes?.url;
        // console.log('Banner image path:', bannerImagePath);

        return bannerImagePath ? `${ip}${bannerImagePath}` : null; // Return image URL if available
      }

      return null; // Return null if CoverSlide is not 'yes'
    } catch (error) {
      console.error('Error fetching banner image:', error);
      return null; // Return null in case of error
    }
  };

  // Helper function to add the first introduction slide with banner image
  const addIntroductionSlide = async () => {
    const slide = ppt.addSlide();
    const bannerImage = await getBannerImage(); // Get the banner image if applicable

    // If banner image is available, add it as the background
    if (bannerImage) {
      // console.log("Adding banner image:", bannerImage);
      slide.addImage({
        path: bannerImage,
        x: 0,
        y: 0,
        w: '100%',
        h: '100%'
      });
    }
  };

  // Function to scale image proportionally
  const scaleImage = async (imagePath, maxWidth, maxHeight) => {
    const img = new Image();
    img.src = imagePath;
    return new Promise(resolve => {
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        let width = maxWidth;
        let height = maxHeight;

        if (img.width > img.height) {
          height = width / aspectRatio;
        } else {
          width = height * aspectRatio;
        }

        // Ensure it fits within maxWidth and maxHeight
        if (width > maxWidth) {
          width = maxWidth;
          height = width / aspectRatio;
        }
        if (height > maxHeight) {
          height = maxHeight;
          width = height * aspectRatio;
        }

        resolve({ width, height });
      };
    });
  };
  const isValidImage = async url => {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      return response.ok; // If the image exists, it will return a status code of 200
    } catch (error) {
      return false; // Image is invalid or unavailable
    }
  };
  // Function to add image to slide with scaling
  const addImageToSlide = async (slide, imagePath, x, y, maxWidth, maxHeight) => {
    const { width, height } = await scaleImage(imagePath, maxWidth, maxHeight);
    slide.addImage({
      path: imagePath,
      x: x,
      y: y,
      w: width,
      h: height
    });
  };

  // Fetch the banner image and add the introduction slide if necessary
  const bannerImage = await getBannerImage();
  if (bannerImage) {
    await addIntroductionSlide();
  }

  // Helper function to add slides with two products
  const addProductSlide = async (productLeft, cataLeft, productRight, cataRight) => {
    // console.log('productLeft--->', productLeft);
    // console.log('cataLeft--->', cataLeft);
    const slide = ppt.addSlide();

    // Add green filled border
    slide.addShape('rect', {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      line: { color: '#1ec94c', width: 10 }
    });

    if (productLeft) {
      // console.log('productLeft--->', productLeft);
      // console.log('cataLeft--->' , cataLeft)
      if (productLeft.attributes.SetStatus === 'Set') {
        const imageUrl = `${ip}${productLeft?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          if (imageValid) {
            // Scale the image based on max width and height
            const { width, height } = await scaleImage(imageUrl, 2.7, 3);
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }
            await addImageToSlide(slide, image, 0.5, '12%', width, height);
          }
        }

        const detailsLeft = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productLeft.attributes.ProductId || ''
          },
          { label: 'Size :', value: '' }
        ];

        let i = 0;
        detailsLeft.forEach((dim, index) => {
          slide.addText(`${dim.label}${dim.value}`, {
            x: 0.3,
            y: 3.8 + index * 0.3,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
        });

        // const id = productLeft.id;
        // console.log("idddddddd ", id)
        // const catalogueProducts = cataResponse.data.attributes.CatalogueProduct;
        // const catalogProductId = id;
        // console.log("SINGLE ", catalogueProducts)

        // const filteredProducts = catalogueProducts.filter(
        //   product => product.CatalogProduct == catalogProductId
        // );
        // console.log("selected cata product :", filteredProducts)

        let yDis = 4.1;

        // const productSizes = cataResponse.data.attributes.ProductSizes;
        // console.log("SET SET SET :", productSizes)

        const dimensions = catalogueCatProductSize
          .filter(item => item.CatalogueProduct === cataLeft.CatalogProduct)
          .map(size => ({
            value: `${
              size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
            } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
          }));

        dimensions.forEach((dim, index) => {
          if (i > 3) return;
          slide.addText(`${dim.value}`, {
            x: 1.2,
            y: 4.1 + index * 0.2,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
          yDis += 0.2;
          i++;
        });

        // const dimensionsColor = productLeft.attributes.SetSizes.map(size => ({
        //   value: `${size.ColorName}`
        // }));
        let allColorData = [];
        let page = 1;

        while (true) {
          const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
          const result = await response.json();

          if (result.data) {
            allColorData = allColorData.concat(result.data);
          }

          if (page >= result.meta.pagination.pageCount) break;

          page++;
        }
        const dimensionsColor = catalogueCatProductSize
          .filter(size => size.CatalogueProduct == cataLeft.CatalogProduct) // Filter by CatalogueProduct ID
          .map(size => {
            // Find the matching color name for the given color code
            const color = colordata.find(c => c?.attributes?.ColorCode == size?.ColorCode);
            // console.log("color dataaaaa", allColorData)
            // console.log("colorrrrrr", color)
            return {
              value: color ? color?.attributes?.ColorName : size?.ColorCode // Use color name if found, else fallback to color code
            };
          });
        let finalColor = dimensionsColor
          .filter(item => item.value != '' && item.value != 'null')
          .map(item => item.value)
          .join(' / ');
        if (finalColor == ' / ') {
          finalColor = '';
        }
        slide.addText(`${label[0].attributes.color}         : ${finalColor}`, {
          x: 0.3,
          y: yDis + 0.1,
          fontSize: 11,
          fontFace: 'Algerian',
          color: '#000000'
        });
        // dimensionsColor.forEach((dim, index) => {
        //   slide.addText(
        //     `${dim.value !== '' ? dim.value : ''}${index < dimensionsColor.length - 1 ? '/' : ''
        //     }`,
        //     {
        //       x: 1.2 + index * 0.6,
        //       y: yDis + 0.1,
        //       fontSize: 11,
        //       fontFace: 'Algerian',
        //       color: '#000000'
        //     }
        //   );
        // });
      } else {
        const imageUrl = `${ip}${productLeft?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          // Scale the image based on max width and height
          if (imageValid) {
            const { width, height } = await scaleImage(imageUrl, 2.7, 3); // Scaling
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            slide.addImage({
              path: image,
              x: 0.5, // Left alignment
              y: '12%',
              w: width, // Adjust width based on scale
              h: height // Adjust height based on scale
            });
          }
        }
        // const { Description, ProductId, Length, Width, Height, SizeUnit, ColorName } =
        //   productLeft.attributes;
        // Left product details
        // const id = productLeft.id;
        // console.log("idddddddd ", id)
        // const catalogueProducts = cataResponse.data.attributes.CatalogueProduct;
        // const catalogProductId = id;
        // console.log("SINGLE ", catalogueProducts)

        // const filteredProducts = catalogueProducts.filter(
        //   product => product.CatalogProduct == catalogProductId
        // );
        // console.log("selected cata product :", filteredProducts)
        const { len, wid, thick, unit, color } = cataLeft;
        const convertedLen = convertDimension(len, unit, selectedUnit);

        const convertedWid = convertDimension(wid, unit, selectedUnit);

        const convertedThick = convertDimension(thick, unit, selectedUnit);

        const sizeValue =
          convertedLen == 0 && convertedWid == 0 && convertedThick == 0
            ? ''
            : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
        const detailsLeft = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productLeft.attributes.ProductId || ''
          },
          {
            label: `Size :`,
            value: sizeValue || ''
          },
          {
            label: `${label[0].attributes.color} :`,
            value: color && color !== 'null' ? color : ''
          }
        ];

        detailsLeft.forEach((detail, index) => {
          slide.addText(`${detail.label} ${detail.value}`, {
            x: 0.5, // Left alignment
            y: 4 + index * 0.3, // Bottom-left positioning
            fontSize: 11,
            fontFace: 'Algerian', // Algerian font
            align: 'left',
            color: '#000000'
          });
        });
      }
    }

    // Right product
    if (productRight) {
      if (productRight.attributes.SetStatus === 'Set') {
        const imageUrl = `${ip}${productRight?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageValid = await isValidImage(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }

        if (imageValid) {
          if (imageValid) {
            const { width, height } = await scaleImage(imageUrl, 2.7, 3);
            await addImageToSlide(slide, image, 6.5, '40%', width, height);
          }
        }
        const detailsRight = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productRight.attributes.ProductId || ''
          },
          { label: 'Size :', value: '' }
        ];

        let i = 0;
        detailsRight.forEach((dim, index) => {
          slide.addText(`${dim.label}${dim.value}`, {
            x: 6.3,
            y: 0.8 + index * 0.3,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
        });

        // const id = productRight.id;
        // console.log("idddddddd ", id)
        // const catalogueProducts = cataResponse.data.attributes.CatalogueProduct;
        // const catalogProductId = id;
        // console.log("SINGLE ", catalogueProducts)

        // const filteredProducts = catalogueProducts.filter(
        //   product => product.CatalogProduct == catalogProductId
        // );
        // console.log("selected cata product :", filteredProducts)

        let yDis = 1.1;

        //   const productSizes = cataResponse.data.attributes.ProductSizes;
        // console.log("SET SET SET :", productSizes)

        const dimensions = catalogueCatProductSize
          .filter(item => item.CatalogueProduct === cataRight.CatalogProduct)
          .map(size => ({
            value: `${
              size.Description && size.Description !== 'null' ? size.Description + ' -' : '    '
            } ${size.Length}x${size.Width}x${size.Height} ${size.Unit}`
          }));

        dimensions.forEach((dim, index) => {
          if (i > 3) return;
          slide.addText(`${dim.value}`, {
            x: 7.2,
            y: 1.1 + index * 0.2,
            fontSize: 11,
            fontFace: 'Algerian',
            color: '#000000'
          });
          yDis += 0.2;
          i++;
        });

        // const dimensionsColor = productRight.attributes.SetSizes.map(size => ({
        //   value: `${size.ColorName}`
        // }));
        let allColorData = [];
        let page = 1;

        while (true) {
          const response = await fetch(`${ip}/api/mstcolors?populate=*&pagination[page]=${page}`);
          const result = await response.json();

          if (result.data) {
            allColorData = allColorData.concat(result.data);
          }

          if (page >= result.meta.pagination.pageCount) break;

          page++;
        }

        const dimensionsColor = catalogueCatProductSize
          .filter(size => size.CatalogueProduct == cataRight.CatalogProduct) // Filter by CatalogueProduct ID
          .map(size => {
            // Find the matching color name for the given color code
            const color = colordata.find(c => c?.attributes?.ColorCode == size?.ColorCode);
            return {
              value: color ? color?.attributes?.ColorName : size?.ColorCode // Use color name if found, else fallback to color code
            };
          });

        let finalColor = dimensionsColor
          .filter(item => item.value != '' && item.value != 'null')
          .map(item => item.value)
          .join(' / ');
        if (finalColor == '/ ') {
          finalColor = '';
        }
        // Split finalColor into an array of individual color names
        const colorArray = finalColor.split(' / ');

        // Group the colors into chunks of 2
        let colorChunks = [];
        for (let i = 0; i < colorArray.length; i += 2) {
          colorChunks.push(colorArray.slice(i, i + 2).join(' / ')); // Join every two colors with " / "
        }

        // Add each chunk of colors to the slide

        let yPosition = yDis + 0.1;
        colorChunks.forEach((chunk, index) => {
          if (index == 0) {
            slide.addText(`${label[0].attributes.color}         : ${chunk}`, {
              x: 6.3,
              y: yPosition,
              fontSize: 11,
              fontFace: 'Algerian',
              color: '#000000'
            });
            yPosition += 0.3; // Adjust vertical spacing for each new line
          } else {
            slide.addText(
              `${printStringNTimes(' ', label[0].attributes.color.length)}         ${chunk}`,
              {
                x: 6.3,
                y: yPosition,
                fontSize: 11,
                fontFace: 'Algerian',
                color: '#000000'
              }
            );
            yPosition += 0.3; // Adjust vertical spacing for each new line
          }
        });
      } else {
        const imageUrl = `${ip}${productRight?.attributes?.CoverImage?.data?.attributes?.url}`;
        // console.log("Right Product Image URL:", imageUrl);
        const imageValid = await isValidImage(imageUrl);
        if (imageValid) {
          if (imageValid) {
            const { width, height } = await scaleImage(imageUrl, 2.7, 3); // Scaling
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            slide.addImage({
              path: image,
              x: 6.5, // Right alignment
              y: '40%',
              w: width, // Adjust width for 40% smaller size (60% of 4.5)
              h: height // Adjust height for 40% smaller size (60% of 5)
            });
          }
        }
        // const id = productRight.id;
        // console.log("idddddddd ", id)
        // const catalogueProducts = cataResponse.data.attributes.CatalogueProduct;
        // const catalogProductId = id;
        // console.log("SINGLE ", catalogueProducts)

        // const filteredProducts = catalogueProducts.filter(
        //   product => product.CatalogProduct == catalogProductId
        // );
        // console.log("selected cata product :", filteredProducts)
        // const { len, wid, thick, unit, color, CatalogueProduct } = filteredProducts[0];
        const { len, wid, thick, unit, color } = cataRight;
        const convertedLen = convertDimension(len, unit, selectedUnit);

        const convertedWid = convertDimension(wid, unit, selectedUnit);

        const convertedThick = convertDimension(thick, unit, selectedUnit);

        const sizeValue =
          convertedLen == 0 && convertedWid == 0 && convertedThick == 0
            ? ''
            : `${convertedLen} x ${convertedWid} x ${convertedThick} ${selectedUnit}`;
        const detailsRight = [
          {
            label: `${label[0].attributes.AliasCode} :`,
            value: productRight.attributes.ProductId || ''
          },
          {
            label: `Size :`,
            value: sizeValue || ''
          },
          {
            label: `${label[0].attributes.color} :`,
            value: color && color !== 'null' ? color : ''
          }
        ];

        detailsRight.forEach((detail, index) => {
          slide.addText(`${detail.label} ${detail.value}`, {
            x: 6.5, // Right alignment
            y: 0.8 + index * 0.3, // Top-right positioning
            fontSize: 11,
            fontFace: 'Algerian', // Algerian font
            align: 'left',
            color: '#000000'
          });
        });
      }
    }
  };

  for (let i = 0; i < cataloguecatappt.length; i += 2) {
    const productLeft = cata.find(pro => pro.id === Number(cataloguecatappt[i].CatalogProduct));

    const productRight = cata.find(
      pro => pro.id === Number(cataloguecatappt[i + 1]?.CatalogProduct)
    );

    await addProductSlide(
      productLeft,
      cataloguecatappt[i],
      productRight,
      cataloguecatappt[i + 1] ? cataloguecatappt[i + 1] : null
    );
  }
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  // Download the PPT file
  ppt.writeFile({ fileName: 'ppt' });
};
const handleDownloadPPT8 = async (
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  cataloguecatappt,
  label,
  productAlias,
  productdesc,
  buyercata = []
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT8');

  // Helper function to get image dimensions
  const getImageDimensions = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };
      img.onerror = reject;
      img.src = imageUrl;
    });
  };
  const addHeaderToSlide = (slide, headerText = 'Header Content') => {
    // Add a rectangle (box)
    const rectWidth = 9; // Adjust width as needed
    const rectHeight = 0.6; // Adjust height as needed
    slide.addShape('rect', {
      x: 0.5,
      y: 0.2,
      w: rectWidth,
      h: rectHeight,
      fill: '#000000',
      line: { color: '#ffffff', width: 0.01 }
    });

    // Add text inside the box
    slide.addText(headerText, {
      x: 0.6,
      y: 0.25,
      w: rectWidth - 0.2, // Adjust width for text padding
      h: rectHeight - 0.1, // Adjust height for text padding
      color: '#ffffff',
      fontSize: 14,
      bold: true,
      align: 'center'
    });

    // Add the logo image if available
    const logoImageUrl = catappt[0]?.attributes?.HPath?.data?.attributes?.url;
    const img = `${ip}${logoImageUrl}` || garment1;

    if (img) {
      const logoOptions = {
        x: 0.5, // Adjust x to center logo within the rectangle
        y: 0.2, // Align logo with the top of the rectangle
        w: rectWidth, // Take the full width of the rectangle
        h: rectHeight // Take the full height of the rectangle
      };
      slide.addImage({ path: img, ...logoOptions });
    }
  };
  // Function to add the introduction slide
  const addIntroductionSlide = () => {
    const slide = ppt.addSlide();
    addHeaderToSlide(slide, 'Introduction');
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const logoImageUrl = catappt[0]?.attributes?.CSPath?.data?.attributes?.url;
    const img = logoImageUrl ? `${ip}${logoImageUrl}` : garment1;

    // Add header shapes
    slide.addShape('rect', {
      x: 0,
      y: 0,
      w: '100%',
      h: 5.6,
      fill: '#eff1f0'
    });

    slide.addShape('rect', {
      x: 1,
      y: 4.5,
      w: '10%',
      h: 0.5,
      fill: '#2f7a7c'
    });

    slide.addShape('rect', {
      x: 2.1,
      y: 4.5,
      w: '74%',
      h: 0.5,
      fill: '#afafaf'
    });

    // Add logo image
    if (img) {
      slide.addImage({
        path: img,
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6
      });
    }
  };

  addIntroductionSlide();

  // Function to add product slides
  const addProductSlides = async (products, catalogue) => {
    const slide = ppt.addSlide();
    addHeaderToSlide(slide, 'Introduction');
    let xOffset = 0.9;

    const tableRows = [];

    for (const product of products) {
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

      try {
        const { width, height } = await getImageDimensions(imageUrl);
        const aspectRatio = width / height;
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }
        const maxWidth = 2.5;
        const maxHeight = 2.5;

        let imgWidth = maxWidth;
        let imgHeight = maxHeight;

        if (aspectRatio > 1) {
          imgHeight = maxWidth / aspectRatio; // Adjust height based on width
        } else {
          imgWidth = maxHeight * aspectRatio; // Adjust width based on height
        }

        // Add product image
        slide.addImage({
          path: image,
          x: xOffset,
          y: 1,
          w: imgWidth,
          h: imgHeight
        });
      } catch (error) {
        console.error('Error loading image:', error);
      }
      const tableRows = [];
      let yOffset = 0.1;
      catalogue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (productAlias) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                bold: true,
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd}`,
              options: {
                fontSize: 8,
                fontFace: 'Raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                bold: true,
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (productdesc) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'top'
              }
            };
            const discValCell = {
              text: `${catalogItem.description}`,
              options: {
                fontSize: 8,
                fontFace: 'Raleway',
                color: '#000000',
                border: { pt: 1, color: '#808080' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: xOffset - 0.8,
        y: 4.5,
        w: 4.8,
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: false
      };

      slide.addTable(tableRows, tableOptions);
      // Update xOffset to position the next product
      xOffset += 5;
    }
  };

  let serialCounter = 0;
  const slidesToAdd = [];

  // Split products into slides
  while (serialCounter < cata.length) {
    const productsOnSlide = cata.slice(serialCounter, serialCounter + 2);
    slidesToAdd.push(addProductSlides(productsOnSlide, cataloguecatappt)); // Collect promises
    serialCounter += 2;
  }

  // Wait for all product slides to be added
  await Promise.all(slidesToAdd);
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  // Download the PPT file after all slides are processed
  ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
};
const handleDownloadPPT7 = async (
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  buyercata = []
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT7');

  // Helper function to get image dimensions
  const getImageDimensions = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };
      img.onerror = reject;
      img.src = imageUrl;
    });
  };
  const addHeaderToSlide = (slide, headerText = 'Header Content') => {
    // Add a rectangle (box)
    const rectWidth = 9; // Adjust width as needed
    const rectHeight = 0.6; // Adjust height as needed
    slide.addShape('rect', {
      x: 0.5,
      y: 0.2,
      w: rectWidth,
      h: rectHeight,
      fill: '#000000',
      line: { color: '#ffffff', width: 0.01 }
    });

    // Add text inside the box
    slide.addText(headerText, {
      x: 0.6,
      y: 0.25,
      w: rectWidth - 0.2, // Adjust width for text padding
      h: rectHeight - 0.1, // Adjust height for text padding
      color: '#ffffff',
      fontSize: 14,
      bold: true,
      align: 'center'
    });

    // Add the logo image if available
    const logoImageUrl = catappt[0]?.attributes?.HPath?.data?.attributes?.url;
    const img = `${ip}${logoImageUrl}` || garment1;

    if (img) {
      const logoOptions = {
        x: 0.5, // Adjust x to center logo within the rectangle
        y: 0.2, // Align logo with the top of the rectangle
        w: rectWidth, // Take the full width of the rectangle
        h: rectHeight // Take the full height of the rectangle
      };
      slide.addImage({ path: img, ...logoOptions });
    }
  };

  // Function to add introduction slide
  const addIntroductionSlide = () => {
    const slide = ppt.addSlide();
    addHeaderToSlide(slide, 'Introduction'); // Add header
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const logoImageUrl = catappt[0]?.attributes?.CSPath?.data?.attributes?.url;
    const img = `${ip}${logoImageUrl}` || garment1;

    const headerBackground = {
      x: 0,
      y: 0,
      w: '100%',
      h: 5.6,
      fill: '#eff1f0'
    };
    slide.addShape('rect', headerBackground);

    const headerBackground1 = {
      x: 1,
      y: 4.5,
      w: '10%',
      h: 0.5,
      fill: '#2f7a7c'
    };
    slide.addShape('rect', headerBackground1);

    const headerBackground2 = {
      x: 2.1,
      y: 4.5,
      w: '74%',
      h: 0.5,
      fill: '#afafaf'
    };
    slide.addShape('rect', headerBackground2);

    // Add the logo image if available
    if (img) {
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6
      };
      slide.addImage({ path: img, ...logoOptions });
    }
  };

  addIntroductionSlide();

  // Function to add product slides
  const addProductSlides = async products => {
    const slide = ppt.addSlide();
    addHeaderToSlide(slide, 'Product Details');
    let xOffset = 0.7;

    for (const product of products) {
      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

      try {
        const { width, height } = await getImageDimensions(imageUrl);
        let image = imageUrl;
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }
        const aspectRatio = width / height;

        const maxWidth = 2.5;
        const maxHeight = 2.5;

        let imgWidth = maxWidth;
        let imgHeight = maxHeight;

        if (aspectRatio > 1) {
          imgHeight = maxWidth / aspectRatio; // Adjust height based on width
        } else {
          imgWidth = maxHeight * aspectRatio; // Adjust width based on height
        }

        const imageOptionsc = {
          x: xOffset,
          y: 1,
          w: imgWidth,
          h: imgHeight
        };

        slide.addImage({ path: image, ...imageOptionsc });
      } catch (error) {
        console.error('Error loading image:', error);
      }

      // Create a table for product attributes
      const tableRows = [];
      let yOffset = 0.1;

      if ('ProductId' in product.attributes) {
        const productidAttrCell = {
          text: 'Alias Code',
          options: {
            fontSize: 10,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };

        const productidValCell = {
          text: `  ${product.attributes.ProductId?.toString() || ''}`,
          options: {
            fontSize: 8,
            fontFace: 'Raleway',
            color: '#000000',
            border: { pt: 1, color: '#808080' },
            valign: 'middle'
          }
        };

        tableRows.push([
          productidAttrCell,
          { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
        ]);
        yOffset += 0.1;
      }

      const tableOptions = {
        x: xOffset,
        y: 4,
        w: 2,
        fontSize: 8,
        fontFace: 'Arial',
        autoPage: true
      };

      slide.addTable(tableRows, tableOptions);

      xOffset += 3; // Increment xOffset to position the next product
    }
  };

  let serialCounter = 0;
  const slidesToAdd = [];

  while (serialCounter < cata.length) {
    const productsOnSlide = cata.slice(serialCounter, serialCounter + 3).sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    });
    slidesToAdd.push(addProductSlides(productsOnSlide)); // Collect promises
    serialCounter += 3;
  }

  // Wait for all product slides to be added before downloading the PPT
  await Promise.all(slidesToAdd);
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  // Now download the PPT file after all slides are processed
  ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
};
const handleDownloadPPT9 = async (
  cata,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  label
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT9');

  const getImageDimensions = async imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.width, height: img.height });
      img.onerror = reject;
      img.src = imageUrl;
    });
  };

  const addHeaderToSlide = async slide => {
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
    const container = { x: 0, y: 0, w: 10, h: 1 };
    slide.addShape('rect', container);

    if (logoImageUrl) {
      const logoFullPath = `${ip}${logoImageUrl}`;
      try {
        const { width: imgWidth, height: imgHeight } = await getImageDimensions(logoFullPath);
        const containerAspectRatio = container.w / container.h;
        const imageAspectRatio = imgWidth / imgHeight;

        let scaledWidth, scaledHeight, offsetX, offsetY;
        if (imageAspectRatio > containerAspectRatio) {
          scaledWidth = container.w;
          scaledHeight = container.w / imageAspectRatio;
          offsetX = 0;
          offsetY = (container.h - scaledHeight) / 2;
        } else {
          scaledWidth = container.h * imageAspectRatio;
          scaledHeight = container.h;
          offsetX = (container.w - scaledWidth) / 2;
          offsetY = 0;
        }

        slide.addImage({
          path: logoFullPath,
          x: container.x + offsetX,
          y: container.y + offsetY,
          w: scaledWidth,
          h: scaledHeight
        });
      } catch (error) {
        console.error('Error loading header image:', logoFullPath, error);
      }
    }
  };

  const addIntroductionSlide = () => {
    const slide = ppt.addSlide();
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const logoImageUrl = firstItem?.attributes?.CSPath?.data?.attributes?.url;
    const img = `${ip}${logoImageUrl}` || garment1;

    slide.addShape('rect', { x: 0, y: 0, w: '100%', h: 5.6, fill: '#eff1f0' });
    slide.addShape('rect', { x: 1, y: 4.5, w: '10%', h: 0.5, fill: '#2f7a7c' });
    slide.addShape('rect', { x: 2.1, y: 4.5, w: '74%', h: 0.5, fill: '#afafaf' });

    if (img) {
      slide.addImage({
        path: img,
        x: 0,
        y: 0,
        w: '100%',
        h: 5.6,
        sizing: { type: 'contain' }
      });
    }
  };

  const catah = catappt[0]?.attributes?.Header;
  const catahb = buyercata[0]?.attributes?.Header;

  const addProductSlides = async products => {
    const slide = ppt.addSlide();

    if (catah === 'Yes') await addHeaderToSlide(slide);
    if (catahb === 'Yes') await addHeaderToSlide(slide);

    const slideWidth = 10;
    const productWidth = 2.9;
    const productHeight = 2.35;
    const xGap = 0.1;
    const yGap = 0.1;

    const columns = 2;
    const totalRowWidth = productWidth * columns + xGap;
    const xOffset = (slideWidth - totalRowWidth) / 2;
    const yOffset = 0.8;

    for (let i = 0; i < products.length; i++) {
      const product = products[i];
      const col = i % columns;
      const row = Math.floor(i / columns);

      const x = xOffset + col * (productWidth + xGap);
      const y = yOffset + row * (productHeight + yGap);

      const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

      try {
        let image = imageUrl;

        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' });
          image = URL.createObjectURL(blob);
        }

        // 🟦 Draw container box (no fill, border only)
        slide.addShape(ppt.ShapeType.rect, {
          x,
          y,
          w: productWidth,
          h: productHeight
          // line: { color: '808080', width: 1 }, // grey border
          // fill: { color: 'FFFFFF' },           // optional: white background
        });

        // 📐 Load image to get natural size
        const img = new Image();
        img.src = image;

        await new Promise(resolve => {
          img.onload = () => {
            const imgRatio = img.width / img.height;
            const boxRatio = productWidth / productHeight;

            let imgW, imgH, imgX, imgY;

            if (imgRatio > boxRatio) {
              imgW = productWidth;
              imgH = productWidth / imgRatio;
            } else {
              imgH = productHeight;
              imgW = productHeight * imgRatio;
            }

            imgX = x + (productWidth - imgW) / 2;
            imgY = y + (productHeight - imgH) / 2;

            // 🖼️ Add image inside container (centered)
            slide.addImage({
              path: image,
              x: imgX,
              y: imgY,
              w: imgW,
              h: imgH
            });

            resolve();
          };

          img.onerror = err => {
            console.error('Image failed to load:', image, err);
            resolve();
          };
        });

        // 🔤 Add Alias Code beside the image
        if ('ProductId' in product.attributes) {
          const aliasWidth = 2;
          const aliasRows = [
            [
              {
                text: `${label[0]?.attributes.AliasCode}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Raleway',
                  color: '#000000',
                  valign: 'middle'
                }
              },
              {
                text: product.attributes.ProductId?.toString() || '',
                options: {
                  fontSize: 8,
                  fontFace: 'Raleway',
                  color: '#000000',
                  valign: 'middle'
                }
              }
            ]
          ];

          const aliasX = col === 0 ? x - aliasWidth - 0.05 + 0.3 : x + productWidth + 0.05 + 0.3;
          const aliasY = y + productHeight / 2 - 1.18;

          slide.addTable(aliasRows, {
            x: aliasX,
            y: aliasY,
            w: aliasWidth,
            h: 0.2,
            fontSize: 8,
            fontFace: 'Arial',
            colW: [0.7, 0.8],
            autoPage: false,
            border: { pt: 1, color: '#b8b8b8' }
          });
        }
      } catch (error) {
        console.error('Error processing product image:', error);
      }
    }
  };

  addIntroductionSlide();

  let serialCounter = 0;
  while (serialCounter < cata.length) {
    const productsOnSlide = cata.slice(serialCounter, serialCounter + 4);
    await addProductSlides(productsOnSlide);
    serialCounter += 4;
  }
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
};

const handleDownloadPPT4 = async (
  cata,
  data2,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName
) => {
  const ppt = new pptxgen();
  // console.log('handleDownloadPPT4');

  // Helper function to add a slide with the product image and attributes
  const getImageSize = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = err => {
        reject(err);
      };
      img.src = imageUrl;
    });
  };
  const addIntroductionSlide = ppt => {
    const slide = ppt.addSlide();
    const firstItem = data2.length > 0 ? data2[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const email = firstItem?.attributes.email_id || '';
    const wesite = firstItem?.attributes.website || '';
    const logoImageUrl = firstItem?.attributes?.Logo?.data?.attributes?.url || '';

    // Add the logo image if the URL is available
    if (logoImageUrl) {
      const logoOptions = {
        x: 3.2, // Adjust the x-coordinate of the logo
        y: 0.5, // Adjust the y-coordinate of the logo
        w: 4, // Adjust the width of the logo
        h: 1 // Adjust the height of the logo
      };
      const logoFullPath = `${ip}${logoImageUrl}`;
      slide.addImage({ path: logoFullPath, ...logoOptions });
    }

    // Customize the content of the introduction slide as needed
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
        }
      ],
      { x: 1.4, y: 2, align: 'center' }
    );
    slide.addText(address, {
      x: 1.4,
      y: 2.5,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#000000',
      align: 'center'
    });
    slide.addText(email, {
      x: 1.4,
      y: 2.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#000000',
      align: 'center'
    });
    slide.addText(wesite, {
      x: 1.4,
      y: 3.1,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#000000',
      align: 'center'
    });
    // Add more text or content as desired
  };
  // const catacover = catappt[0]?.attributes?.CoverSlide;
  // if (catacover == 'Yes') {
  //   addIntroductionSlide();
  // }
  // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
  // if (catacoverb == 'Yes') {
  //   addIntroductionSlide();
  // }
  const addProductSlide = async (product, ppt) => {
    const slide = ppt.addSlide();

    const firstItem = data2.length > 0 ? data2[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 16, fontFace: 'Aileron Black', color: '#444343', underline: true }
        }
      ],
      { x: 1.4, y: 0.5, align: 'center' }
    );

    const logoImageUrl = firstItem?.attributes?.Logo?.data?.attributes?.url || '';
    const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;

    try {
      // Wait for the image to load and get its size
      const { width, height } = await getImageSize(imageUrl);
      let image = imageUrl;
      if (watermark) {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        image = imageUrl2;
      }
      // Define the maximum width and height for the image on the slide (adjust these values as needed)
      const maxWidth = 5; // Maximum width in inches
      const maxHeight = 3.5; // Maximum height in inches

      // Calculate the aspect ratio
      const aspectRatio = width / height;

      // Scale the image to fit within the slide's boundaries
      let imageWidth = width;
      let imageHeight = height;

      // Check if the image exceeds the max dimensions and scale it down
      if (width > maxWidth || height > maxHeight) {
        if (aspectRatio > 1) {
          // Scale by width if the image is wider than tall
          imageWidth = maxWidth;
          imageHeight = maxWidth / aspectRatio;
        } else {
          // Scale by height if the image is taller than wide
          imageHeight = maxHeight;
          imageWidth = maxHeight * aspectRatio;
        }
      }

      // Ensure the image is constrained within the slide's width and height
      if (imageWidth > maxWidth) imageWidth = maxWidth;
      if (imageHeight > maxHeight) imageHeight = maxHeight;

      const imageOptions = {
        x: 0.5,
        y: 1.2,
        w: imageWidth, // Use scaled width
        h: imageHeight // Use scaled height
      };

      slide.addImage({ path: image, ...imageOptions });
    } catch (err) {
      console.error('Error loading image:', err);
    }

    // Add the product attributes as a table

    if (
      product.attributes.MultipleImage &&
      product.attributes.MultipleImage.data &&
      product.attributes.MultipleImage.data.length > 0
    ) {
      const multipleImages = product.attributes.MultipleImage.data;
      const imageWidth = 1.8; // Adjust the width of each image
      const imageHeight = 1.8; // Adjust the height of each image
      const xOffset = 6; // Adjust the x-offset of the images
      const yOffset = 1.2; // Adjust the initial y-offset of the images

      // Loop through the first two images or the available number of images
      const maxImages = Math.min(2, multipleImages.length);
      for (let index = 0; index < maxImages; index++) {
        const img = multipleImages[index];
        const imageUrl = `${ip}${img.attributes.url}`;
        try {
          // Fetch the original dimensions of the image
          const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);
          let image = imageUrl;
          if (watermark) {
            const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

            // Convert Base64 to ArrayBuffer
            const response = await fetch(mergedImageBase64);
            const imageBuffer = await response.arrayBuffer();
            const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

            // Create a URL from the Blob
            const imageUrl2 = URL.createObjectURL(blob);
            image = imageUrl2;
          }
          // Calculate aspect ratio
          const aspectRatio = originalWidth / originalHeight;

          // Scale image to fit within the bounding box while preserving aspect ratio
          let scaledWidth = originalWidth;
          let scaledHeight = originalHeight;

          if (originalWidth > imageWidth || originalHeight > imageHeight) {
            if (aspectRatio > 1) {
              // Landscape image: scale by width
              scaledWidth = imageWidth;
              scaledHeight = imageWidth / aspectRatio;
            } else {
              // Portrait or square image: scale by height
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * aspectRatio;
            }
          }
          const imageOptions = {
            x: xOffset, // Keep the x-position constant
            y: yOffset + index * imageHeight * 1.2, // Adjust the y-position of each image
            w: scaledWidth,
            h: scaledHeight
          };
          slide.addImage({ path: image, ...imageOptions });
          // slide.addImage({ path: imageUrl, ...imageOptions });
        } catch (err) {
          console.error('Error loading image dimensions:', err);
        }
      }
    }

    const tableRows = [];

    if ('ProductId' in product.attributes) {
      const productIdAttrCell = {
        text: 'Alias Code',
        options: { fontSize: 8, fontFace: 'Arial Black', color: '#444343' }
      };
      const productIdValCell = {
        text: `: ${product.attributes.ProductId?.toString() || ''}`,
        options: { fontSize: 8, fontFace: 'Times New Roman', color: '#000000' }
      };
      const yOffset = 7; // Adjust the y-coordinate as needed
      const productIdOptions = { ...productIdValCell.options, y: yOffset };
      tableRows.push([productIdAttrCell, { ...productIdValCell, options: productIdOptions }]);
    }

    // ... (continue adding other attributes to the table)

    const tableOptions = {
      x: 0.5,
      y: 4.8,
      w: '20%', // Adjust the width of the table as needed
      fontSize: 8, // Adjust the font size as needed
      fontFace: 'Arial', // Set the font face
      autoPage: true // Enable automatic paging if the table exceeds slide size
    };

    slide.addTable(tableRows, tableOptions);
  };

  // Loop through each item in cata and add a slide for each product
  // reversedCata.forEach(item => {
  //   addProductSlide(item);
  // });
  // for (let item of cata) {
  //   await addProductSlide(item); // Ensure to await each slide creation
  // }
  // // Download the PPT file
  // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

  let catalogueIndex = 1;

  // Check if `cata` is a flat array (not a multidimensional array)
  if (Array.isArray(cata) && !Array.isArray(cata[0])) {
    // If `cata` is a flat array, process all products directly
    const ppt = new pptxgen();

    const catacover = catappt[0]?.attributes?.CoverSlide;
    const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // const headerimg = catappt[0]?.attributes?.HPath;
    // const headerimgb = buyercata[0]?.attributes?.HPath;
    // const catah = catappt[0]?.attributes?.Header;
    // const catahb = buyercata[0]?.attributes?.Header;

    // Add introduction slide if needed
    if (catacover === 'Yes' || catacoverb === 'Yes') {
      await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
    }

    let serialCounter = 1;
    for (let product of cata) {
      // Ensure product is valid before adding slide
      if (product) {
        await addProductSlide(product, ppt); // Pass ppt is not needed
        serialCounter++;
      } else {
        console.warn('Skipping invalid product:', product);
      }
    }

    // Generate the final PowerPoint file
    const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
    await ppt.writeFile({ fileName });

    catalogueIndex++;
  } else {
    // If `cata` is a multidimensional array (e.g., array of catalogues)
    for (let catalogue of cata) {
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      // const catah = catappt[0]?.attributes?.Header;
      // const catahb = buyercata[0]?.attributes?.Header;

      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed
      }

      let serialCounter = 1;
      for (let product of catalogue) {
        await addProductSlide(product, ppt); // Pass ppt is not needed
        serialCounter++;
      }

      const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    }
  }
};
const handleDownloadPPT15 = async (
  cata,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  catalogueCatProductSize,
  sizeshow,
   unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm,
  // productMaterialName,
  // productInnerAndMaster,
  // productMoq,
  // ptech,
  // madeby
  {
    // console.log('handleDownloadPPT15');
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };

    const response = await fetch(`${ip}/api/mstfinishes?populate=*&pagination[pageSize]=100000`);
    const finish = await response.json();

    const addHeaderToSlide = slide => {
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
      const container = {
        x: 0, // Horizontal position (left)
        y: 0, // Vertical position (top)
        w: 10, // Full width of the slide (adjust as needed)
        h: 1 // Height of the container (adjust as needed)
        // fill: { color: 'FF0000' }
      };
      slide.addShape('rect', container);

      if (logoImageUrl) {
        const logoFullPath = `${ip}${logoImageUrl}`;

        // Load the image to get its natural dimensions
        const image = new Image();
        image.src = logoFullPath;

        image.onload = () => {
          const { naturalWidth, naturalHeight } = image;

          // Maintain aspect ratio and scale to fit the container
          const containerAspectRatio = container.w / container.h;
          const imageAspectRatio = naturalWidth / naturalHeight;

          let scaledWidth, scaledHeight, offsetX, offsetY;

          if (imageAspectRatio > containerAspectRatio) {
            // Image is wider than the container
            scaledWidth = container.w;
            scaledHeight = container.w / imageAspectRatio;
            offsetX = 0;
            offsetY = (container.h - scaledHeight) / 2; // Center vertically
          } else {
            // Image is taller or equal aspect ratio
            scaledWidth = container.h * imageAspectRatio;
            scaledHeight = container.h;
            offsetX = (container.w - scaledWidth) / 2; // Center horizontally
            offsetY = 0;
          }

          // Add the image to the slide
          slide.addImage({
            path: logoFullPath,
            x: container.x + offsetX,
            y: container.y + offsetY,
            w: scaledWidth,
            h: scaledHeight
          });
        };

        image.onerror = () => {
          console.error('Error loading image:', logoFullPath);
        };
      }
    };

    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%', // Width spans the entire slide
          h: 5.6, // Height of the header area
          fill: '#eff1f0' // Background color for the header
        };
        // const logoOptions = {
        //   x: 1.2, // Adjust the x-coordinate of the logo
        //   y: 0.6, // Adjust the y-coordinate of the logo
        //   w: 1, // Adjust the width of the logo
        //   h: 0.3 // Adjust the height of the logo
        // };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };

    const catacover = catappt[0]?.attributes?.CoverSlide;
    if (catacover == 'Yes') {
      addIntroductionSlide();
    }
    const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    if (catacoverb == 'Yes') {
      addIntroductionSlide();
    }
    const catah = catappt[0]?.attributes?.Header;
    const catahb = buyercata[0]?.attributes?.Header;
    const addProductSlide = async (product, serialNumber, catalgoue) => {
      const slide = ppt.addSlide();

      if (catah == 'Yes') {
        addHeaderToSlide(slide);
      }
      if (catahb == 'Yes') {
        addHeaderToSlide(slide);
      }

      try {
        const containerWidth = 4; // Container width in inches
        const containerHeight = 2.1; // Container height in inches

        // Create a red background for the container
        const containerOptions = {
          x: 0.5, // Starting X position for the container
          y: 1.1, // Starting Y position for the container
          w: containerWidth,
          h: containerHeight
          // fill: 'red' // Set the background color to red
        };

        // Add the rectangle container to the slide
        slide.addShape('rect', containerOptions);

        // Add the CoverImage to the container
        const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
        const imageWidth = 2.3; // Adjust the width of each image
        const imageHeight = 2.3;
        const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);
        let image = imageUrl;

        if (watermark && watermarkUrl) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

          // Convert Base64 to ArrayBuffer
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' });

          // Create a URL from the Blob
          const imageUrl2 = URL.createObjectURL(blob);
          image = imageUrl2;
        }

        // Max width and height of the image within the container (adjusted for margin)
        const aspectRatio = originalWidth / originalHeight;

        // Scale image to fit within the bounding box while preserving aspect ratio
        let scaledWidth = originalWidth;
        let scaledHeight = originalHeight;

        if (originalWidth > imageWidth || originalHeight > imageHeight) {
          if (aspectRatio > 1) {
            // Landscape image: scale by width
            scaledWidth = imageWidth;
            scaledHeight = imageWidth / aspectRatio;
          } else {
            // Portrait or square image: scale by height
            scaledHeight = imageHeight;
            scaledWidth = imageHeight * aspectRatio;
          }
        }

        // Center the image within the container
        const xOffset = (containerWidth - scaledWidth) / 2; // Center horizontally
        const yOffset = 0; //
        // Image options with centered position
        const imageOptions = {
          x: 0.5 + xOffset, // Account for the left margin of the container
          y: 0.9 + yOffset, // Account for the top margin of the container
          w: scaledWidth,
          h: scaledHeight
        };

        // Add the CoverImage to the container (red background)
        slide.addImage({ path: image, ...imageOptions });
      } catch (err) {
        console.error('Error creating container or adding images:', err);
      }

      try {
        const containerWidth = 4; // Container width in inches
        const containerHeight = 2.1; // Container height in inches

        // Create a red background for the container
        const containerOptions = {
          x: 0.5, // Starting X position for the container
          y: 3.3, // Starting Y position for the container
          w: containerWidth,
          h: containerHeight
          // fill: 'red' // Set the background color to red
        };

        // Add the rectangle container to the slide
        slide.addShape('rect', containerOptions);

        // Now add MultipleImages (if available) inside the same container
        if (
          product.attributes.MultipleImage &&
          product.attributes.MultipleImage.data &&
          product.attributes.MultipleImage.data.length > 0
        ) {
          const multipleImages = product.attributes.MultipleImage.data.slice(0, 1);
          const imageWidth = 2.3; // Adjust the width of each image
          const imageHeight = 2.3; // Adjust the height of each image

          // Only process the image at index 0
          const img = multipleImages[0];
          const imageUrl = `${ip}${img.attributes.url}`;

          try {
            // Fetch the original dimensions of the image
            const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);
            let image = imageUrl;

            if (watermark && watermarkUrl) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' });

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            // Calculate aspect ratio
            const aspectRatio = originalWidth / originalHeight;

            // Scale image to fit within the bounding box while preserving aspect ratio
            let scaledWidth = originalWidth;
            let scaledHeight = originalHeight;

            if (originalWidth > imageWidth || originalHeight > imageHeight) {
              if (aspectRatio > 1) {
                // Landscape image: scale by width
                scaledWidth = imageWidth;
                scaledHeight = imageWidth / aspectRatio;
              } else {
                // Portrait or square image: scale by height
                scaledHeight = imageHeight;
                scaledWidth = imageHeight * aspectRatio;
              }
            }

            // Center the image within the container
            const xOffset = (containerWidth - scaledWidth) / 2; // Center horizontally
            const yOffset = (containerHeight - scaledHeight) / 2; // Center vertically

            const imageOptions = {
              x: 0.5 + xOffset, // Account for the left margin of the container
              y: 3.3 + yOffset, // Account for the top margin of the container
              w: scaledWidth,
              h: scaledHeight
            };

            slide.addImage({ path: image, ...imageOptions });
          } catch (err) {
            console.error('Error loading image dimensions:', err);
          }
        }
      } catch (err) {
        console.error('Error creating container or adding images:', err);
      }

      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('roductcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const pnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            // Split by words, chunk into 2 lines, then join with newline
            const fullName = `${catalogItem.productname || ''}`;
            const words = fullName.split(' ');
            const line1 = words.slice(0, 6).join(' '); // Adjust word count as needed
            const line2 = words.slice(6, 12).join(' ');
            const truncatedText = [line1, line2].filter(Boolean).join('\n');
            const pnameValCell = {
              text: truncatedText,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              pnameAttrCell,
              { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsize')) {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `Size`,
                    options: {
                      fontSize: 10,
                      fontFace: 'Arial',
                      color: '#000000',
                      fill: '#afafaf',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'Arial',
                      color: '#595959',
                      fill: '#E5E4E2',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let allSize;
                  if (product.attributes.SetStatus === 'Set') {
                    allSize = catalogueCatProductSize.filter(
                      item => item.CatalogueProduct === catalogItem.CatalogProduct
                    );

                    const sizeValues = allSize
                      .slice(0, 3)
                      .map(item => {
                        const { Description, Length, Width, Height, Unit } = item;

                        if (Length === 0 && Width === 0 && Height === 0) {
                          return '';
                        }

                        const descText = Description !== 'null' ? `${Description} - ` : '';
                        return `${descText}${Length} x ${Width} x ${Height} ${Unit}`;
                      })
                      .join('\n'); // Joining values with a new line for better readability

                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Arial',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'top'
                      }
                    };

                    const sizeValCell = {
                      text: sizeValues, // All values in a single cell
                      options: {
                        fontSize: 8,
                        fontFace: 'Arial',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };

                    tableRows.push([sizeAttrCell, sizeValCell]); // Adding a single row
                  } else {
                    const convertedLen = convertDimension(catalogItem.len, catalogItem.unit, unit);

                    const convertedWid = convertDimension(catalogItem.wid, catalogItem.unit, unit);

                    const convertedThick = convertDimension(
                      catalogItem.thick,
                      catalogItem.unit,
                      unit
                    );

                    const sizeValue =
                      convertedLen == 0 && convertedWid == 0 && convertedThick == 0
                        ? ''
                        : `${convertedLen} x ${convertedWid} x ${convertedThick} ${unit}`;
                    // const sizeValue =
                    //   catalogItem.len == 0 && catalogItem.wid == 0 && catalogItem.thick == 0
                    //     ? ''
                    //     : `${catalogItem.len} x ${catalogItem.wid} x ${catalogItem.thick} ${catalogItem.unit}`;
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Raleway',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: ` ${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'Raleway',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }
          if (selectedItems.includes('productMaterialName')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );
              // const matName = allSize.map(item => item.MatName || '').join('/');
              const matName = allSize
                .map(item => item.MatName) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const MaterialNameAttrCell = {
                text: `${label[0]?.attributes.MaterialName}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const MaterialNameValCell = {
                text: `${matName}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                MaterialNameAttrCell,
                { ...MaterialNameValCell, options: { ...MaterialNameValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productfinish')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              // const finishValues = allSize.map(item => item.FinishCode || '').join('/');
              const finishValues = allSize
                .map(item => {
                  const matchedFinish = finish.data.find(
                    finish => finish.attributes.FinishCode === item.FinishCode
                  );
                  return matchedFinish ? matchedFinish.attributes.FinishName : null;
                })
                .filter(value => value !== null) // Remove null values
                .join(' / ');

              // Join with "/"

              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: `${finishValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: ` ${catalogItem.finish}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productsalepri')) {
            // let price = '';
            // if ('currency' in catalogItem && 'saleprice' in catalogItem) {
            //   price =
            //     catalogItem.saleprice === 0 ? '' : `${catalogItem.saleprice} ${catalogItem.currency}`;
            // }
            // let allSize;
            // if (product.attributes.SetStatus === 'Set') {
            //   allSize = catalogueCatProductSize.filter(
            //     item => item.CatalogueProduct === catalogItem.CatalogProduct
            //   );
            //   console.log('allSize', allSize);
            //   // return ;
            //   price = allSize
            //     .map(item => item.Rate) // Extract NetWt values
            //     .filter(value => value !== null && value !== '') // Remove null or empty values
            //     .join('/'); //
            // }
let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;
            const sizeAttrCell = {
              text: 'Price',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text:
                formattedPrice,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              const NetWtValues = allSize
                .map(item => (item.NetWt == 0 ? '' : `${item.NetWt} Kg`)) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: `${NetWtValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: catalogItem.netwgt === 0 ? '' : `${catalogItem.netwgt} Kg`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: catalogItem.cbm === 0 ? '' : `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productInnerAndMaster')) {
            let innerData = product.attributes.Packaging.filter(
              item => item.CartonType === 'inner'
            );
            let masterData = product.attributes.Packaging.filter(
              item => item.CartonType === 'master'
            );
            let innerValue =
              innerData.length <= 0
                ? 0
                : innerData.length === 1
                ? innerData[0].Carton_PCS
                : innerData.reduce((sum, item) => sum + item.Carton_PCS, 0);
            let masterValue =
              masterData.length <= 0 ? 0 : masterData.length === 1 ? masterData[0].Carton_PCS : 1;
            const sizeAttrCell = {
              text: 'Inner/Master',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: `${innerValue} / ${masterValue}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productMoq')) {
            const sizeAttrCell = {
              text: `${label[0]?.attributes.MOQ}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: product.attributes.MOQ == '0' ? '' : `${product.attributes.MOQ} Pcs`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('ptech')) {
            const ptAttrCell = {
              text: `${label[0]?.attributes.P_Technique}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ptValCell = {
              text: `${product?.attributes?.P_Technique}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ptAttrCell,
              { ...ptValCell, options: { ...ptValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('madeby')) {
            const mdAttrCell = {
              text: `${label[0]?.attributes.MadeBy}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const mdValCell = {
              text: `${product?.attributes?.MadeBy}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              mdAttrCell,
              { ...mdValCell, options: { ...mdValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: 5.5,
        y: 0.9,
        // w: '40%', // Adjust the width of the table as needed
        colW: [1.6, 2.7],
        fontSize: 6, // Adjust the font size as needed
        fontFace: 'Arial' // Set the font face
        // autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    const reversedCata = [...cata];
    let serialCounter = 1;
    setLoadPPT(true);
    for (let item of reversedCata) {
      await addProductSlide(item, serialCounter, cataloguecatappt);
      serialCounter++; // Ensure to await each slide creation
    }
    // Download the PPT file
    await addLastSlideSafe({
      ppt,
      buyercata,
      catappt,
      ip
    });
    ppt
      .writeFile({ fileName: `${cataName} PPt.pptx` })
      .then(res => {
        setLoadPPT(false);
        setOpenAttri(false);
      })
      .catch(err => console.log(err));
    // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    setOpen(false);
    setOpenAttri(false);
  };

const handleDownloadPPT16 = async (
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  buyercata,
  setLoadPPT
) => {
  console.log('handleDownloadPPT16');
  const ppt = new pptxgen();
  // Helper function to add a slide with the product image and attributes
  const getImageSize = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = err => {
        reject(err);
      };
      img.src = imageUrl;
    });
  };

  const addHeaderToSlide = slide => {
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
    const container = {
      x: 0, // Horizontal position (left)
      y: 0, // Vertical position (top)
      w: 10, // Full width of the slide (adjust as needed)
      h: 1 // Height of the container (adjust as needed)
      // fill: { color: 'FF0000' }
    };
    slide.addShape('rect', container);

    if (logoImageUrl) {
      const logoFullPath = `${ip}${logoImageUrl}`;

      // Load the image to get its natural dimensions
      const image = new Image();
      image.src = logoFullPath;

      image.onload = () => {
        const { naturalWidth, naturalHeight } = image;

        // Maintain aspect ratio and scale to fit the container
        const containerAspectRatio = container.w / container.h;
        const imageAspectRatio = naturalWidth / naturalHeight;

        let scaledWidth, scaledHeight, offsetX, offsetY;

        if (imageAspectRatio > containerAspectRatio) {
          // Image is wider than the container
          scaledWidth = container.w;
          scaledHeight = container.w / imageAspectRatio;
          offsetX = 0;
          offsetY = (container.h - scaledHeight) / 2; // Center vertically
        } else {
          // Image is taller or equal aspect ratio
          scaledWidth = container.h * imageAspectRatio;
          scaledHeight = container.h;
          offsetX = (container.w - scaledWidth) / 2; // Center horizontally
          offsetY = 0;
        }

        // Add the image to the slide
        slide.addImage({
          path: logoFullPath,
          x: container.x + offsetX,
          y: container.y + offsetY,
          w: scaledWidth,
          h: scaledHeight
        });
      };

      image.onerror = () => {
        console.error('Error loading image:', logoFullPath);
      };
    }
  };

  const addIntroductionSlide = () => {
    const slide = ppt.addSlide();
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const email = firstItem?.attributes.email_id || '';
    const wesite = firstItem?.attributes.website || '';
    const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
    const headerBackground = {
      x: 0,
      y: 0,
      w: '100%', // Width spans the entire slide
      h: 5.6, // Height of the header area
      fill: '#eff1f0' // Background color for the header
    };
    slide.addShape('rect', headerBackground);
    const headerBackground1 = {
      x: 1,
      y: 4.5,
      w: '10%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#2f7a7c' // Background color for the header
    };
    slide.addShape('rect', headerBackground1);
    const headerBackground2 = {
      x: 2.1,
      y: 4.5,
      w: '74%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#afafaf' // Background color for the header
    };
    slide.addShape('rect', headerBackground2);
    // Add the logo image if the URL is available
    if (logoImageUrl) {
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      const logoFullPath = `${ip}${logoImageUrl}`;
      slide.addImage({ path: logoFullPath, ...logoOptions });
    }
    // Customize the content of the introduction slide as needed
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
        }
      ],
      { x: 1.8, y: 2.1, align: 'center' }
    );
    slide.addText(address, {
      x: 1.6,
      y: 2.5,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#303030',
      align: 'center'
    });
    slide.addText(email, {
      x: 0.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    slide.addText(wesite, {
      x: 2.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    // Add more text or content as desired
  };

  const catacover = catappt[0]?.attributes?.CoverSlide;
  if (catacover == 'Yes') {
    addIntroductionSlide();
  }
  const catacoverb = buyercata[0]?.attributes?.CoverSlide;
  if (catacoverb == 'Yes') {
    addIntroductionSlide();
  }
  const catah = catappt[0]?.attributes?.Header;
  const catahb = buyercata[0]?.attributes?.Header;
  const addProductSlide = async (product, serialNumber) => {
    const slide = ppt.addSlide();

    if (catah == 'Yes') {
      addHeaderToSlide(slide);
    }
    if (catahb == 'Yes') {
      addHeaderToSlide(slide);
    }

    try {
      const containerWidth = 4; // Container width in inches
      const containerHeight = 2.1; // Container height in inches

      // Create a red background for the container
      const containerOptions = {
        x: 0.5, // Starting X position for the container
        y: 1.1, // Starting Y position for the container
        w: containerWidth,
        h: containerHeight
      };

      // Add the rectangle container to the slide
      slide.addShape('rect', containerOptions);

      // Add the CoverImage to the container
      const coverImageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      const imageWidth = 2.3; // Adjust the width of each image
      const imageHeight = 2.3;

      const { width: coverImageWidth, height: coverImageHeight } = await getImageSize(
        coverImageUrl
      );
      let coverImage = coverImageUrl;

      if (watermark && watermarkUrl) {
        const mergedImageBase64 = await mergeImagesWithWatermark(coverImageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' });

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        coverImage = imageUrl2;
      }

      // Scale image to fit within the bounding box while preserving aspect ratio
      const coverImageAspectRatio = coverImageWidth / coverImageHeight;
      let scaledWidth = coverImageWidth;
      let scaledHeight = coverImageHeight;

      if (coverImageWidth > imageWidth || coverImageHeight > imageHeight) {
        if (coverImageAspectRatio > 1) {
          // Landscape image: scale by width
          scaledWidth = imageWidth;
          scaledHeight = imageWidth / coverImageAspectRatio;
        } else {
          // Portrait or square image: scale by height
          scaledHeight = imageHeight;
          scaledWidth = imageHeight * coverImageAspectRatio;
        }
      }

      // Center the image within the container
      const xOffset = (containerWidth - scaledWidth) / 2; // Center horizontally
      const yOffset = 0; // Center vertically

      // Image options with centered position
      const imageOptions = {
        x: 0.8 + xOffset, // Account for the left margin of the container
        y: 0.9 + yOffset, // Account for the top margin of the container
        w: scaledWidth,
        h: scaledHeight
      };

      // Add the CoverImage to the container
      slide.addImage({ path: coverImage, ...imageOptions });
    } catch (err) {
      console.error('Error creating container or adding CoverImage:', err);
    }

    // Add Multiple Images (if available)
    try {
      const multipleImages = product?.attributes?.MultipleImage?.data || [];

      if (multipleImages.length > 0) {
        const imageWidth = 2.3; // Adjust the width of each image
        const imageHeight = 2.3; // Adjust the height of each image

        const containerWidth = 4; // Container width in inches
        const containerHeight = 2.1; // Container height in inches
        // const yOffsetStart = 3.3; // Y-coordinate for the first image

        // Process each image and add to the slide
        for (let i = 0; i < Math.min(3, multipleImages.length); i++) {
          const img = multipleImages[i];
          const imageUrl = `${ip}${img?.attributes?.url}`;

          try {
            // Fetch the original dimensions of the image
            const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);
            let image = imageUrl;

            if (watermark && watermarkUrl) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

              // Convert Base64 to ArrayBuffer
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' });

              // Create a URL from the Blob
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            // Scale image to fit within the bounding box while preserving aspect ratio
            const aspectRatio = originalWidth / originalHeight;
            let scaledWidth = originalWidth;
            let scaledHeight = originalHeight;

            if (originalWidth > imageWidth || originalHeight > imageHeight) {
              if (aspectRatio > 1) {
                // Landscape image: scale by width
                scaledWidth = imageWidth;
                scaledHeight = imageWidth / aspectRatio;
              } else {
                // Portrait or square image: scale by height
                scaledHeight = imageHeight;
                scaledWidth = imageHeight * aspectRatio;
              }
            }

            // // Center the image within the container
            // const xOffset = (containerWidth - scaledWidth) / 2; // Center horizontally
            // const yOffset = yOffsetStart + (i * containerHeight); // Offset each image vertically

            // Define positions for each of the four images
            let xPos = 0.5; // Default left offset
            let yPos = 3.3; // Start position for bottom images

            if (i === 0) {
              // Top-left position
              xPos = 6; // Left offset
              yPos = 3.3; // Top offset
            } else if (i === 1) {
              // Top-right position
              xPos = 6; // Right offset
              yPos = 0.9; // Top offset
            } else if (i === 2) {
              // Bottom-left position
              xPos = 1.65; // Left offset
              yPos = 3.3; // Bottom offset
            }

            // Image options with updated position
            const imageOptions = {
              x: xPos, // Horizontal position
              y: yPos, // Vertical position
              w: scaledWidth,
              h: scaledHeight
            };

            // Add the MultipleImage to the container
            slide.addImage({ path: image, ...imageOptions });
          } catch (err) {
            console.error('Error loading image dimensions:', err);
          }
        }
      }
    } catch (err) {
      console.error('Error creating or adding MultipleImages:', err);
    }

    // Add AliasCode label
    slide.addText('AliasCode', {
      x: 0.2,
      y: 1,
      fontSize: 10,
      fontFace: 'Arial',
      color: '000000',
      bold: true
    });

    // Add AliasCode value
    slide.addText(`${product.attributes.ProductId || ''}`, {
      x: 0.2, // slight horizontal offset to show value beside label
      y: 1.2,
      fontSize: 10,
      fontFace: 'Arial',
      color: '595959'
    });
  };

  const reversedCata = [...cata];
  let serialCounter = 1;
  setLoadPPT(true);
  for (let item of reversedCata) {
    await addProductSlide(item, serialCounter);
    serialCounter++; // Ensure to await each slide creation
  }
  await addLastSlideSafe({
    ppt,
    buyercata,
    catappt,
    ip
  });
  // Download the PPT file
  ppt
    .writeFile({ fileName: `${cataName} PPt.pptx` })
    .then(res => {
      setLoadPPT(false);
    })
    .catch(err => console.log(err));
  // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
};
const handleDownloadPPT17 = async (
  cata,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  catalogueCatProductSize,
  sizeshow,
   unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm,
  // productMaterialName,
  // productInnerAndMaster,
  // productMoq,
  // ptech,
  // madeby
  {
    console.log('handleDownloadPPT17');
    const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };

    const response = await fetch(`${ip}/api/mstfinishes?populate=*&pagination[pageSize]=100000`);
    const finish = await response.json();

    const addHeaderToSlide = slide => {
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
      const container = {
        x: 0, // Horizontal position (left)
        y: 0, // Vertical position (top)
        w: 10, // Full width of the slide (adjust as needed)
        h: 1 // Height of the container (adjust as needed)
        // fill: { color: 'FF0000' }
      };
      slide.addShape('rect', container);

      if (logoImageUrl) {
        const logoFullPath = `${ip}${logoImageUrl}`;

        // Load the image to get its natural dimensions
        const image = new Image();
        image.src = logoFullPath;

        image.onload = () => {
          const { naturalWidth, naturalHeight } = image;

          // Maintain aspect ratio and scale to fit the container
          const containerAspectRatio = container.w / container.h;
          const imageAspectRatio = naturalWidth / naturalHeight;

          let scaledWidth, scaledHeight, offsetX, offsetY;

          if (imageAspectRatio > containerAspectRatio) {
            // Image is wider than the container
            scaledWidth = container.w;
            scaledHeight = container.w / imageAspectRatio;
            offsetX = 0;
            offsetY = (container.h - scaledHeight) / 2; // Center vertically
          } else {
            // Image is taller or equal aspect ratio
            scaledWidth = container.h * imageAspectRatio;
            scaledHeight = container.h;
            offsetX = (container.w - scaledWidth) / 2; // Center horizontally
            offsetY = 0;
          }

          // Add the image to the slide
          slide.addImage({
            path: logoFullPath,
            x: container.x + offsetX,
            y: container.y + offsetY,
            w: scaledWidth,
            h: scaledHeight
          });
        };

        image.onerror = () => {
          console.error('Error loading image:', logoFullPath);
        };
      }
    };

    const addIntroductionSlide = () => {
      const slide = ppt.addSlide();
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%', // Width spans the entire slide
          h: 5.6, // Height of the header area
          fill: '#eff1f0' // Background color for the header
        };
        // const logoOptions = {
        //   x: 1.2, // Adjust the x-coordinate of the logo
        //   y: 0.6, // Adjust the y-coordinate of the logo
        //   w: 1, // Adjust the width of the logo
        //   h: 0.3 // Adjust the height of the logo
        // };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };

    const catacover = catappt[0]?.attributes?.CoverSlide;
    if (catacover == 'Yes') {
      addIntroductionSlide();
    }
    const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    if (catacoverb == 'Yes') {
      addIntroductionSlide();
    }
    const catah = catappt[0]?.attributes?.Header;
    const catahb = buyercata[0]?.attributes?.Header;

    const addProductSlide = async (product, serialNumber, catalgoue) => {
      const slide = ppt.addSlide();

      if (catah === 'Yes') addHeaderToSlide(slide);
      if (catahb === 'Yes') addHeaderToSlide(slide);

      try {
        const containerWidth = 5.1; // Container width in inches
        const containerHeight = 4.5; // Increased height for a bigger image
        const containerX = 0.2; // Centered horizontally (assuming 10 inch slide width)
        const containerY = 0.9; // Vertical offset

        // Add background container (can add fill if needed)
        const containerOptions = {
          x: containerX,
          y: containerY,
          w: containerWidth,
          h: containerHeight
          // fill: 'FFFFFF' // Optional background fill
        };

        slide.addShape('rect', containerOptions);

        // Add the CoverImage inside the container
        const imageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
        const maxImageWidth = containerWidth;
        const maxImageHeight = containerHeight;

        const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);

        let image = imageUrl;

        // Apply watermark if needed
        if (watermark && watermarkUrl) {
          const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
          const response = await fetch(mergedImageBase64);
          const imageBuffer = await response.arrayBuffer();
          const blob = new Blob([imageBuffer], { type: 'image/png' });
          image = URL.createObjectURL(blob);
        }

        // Maintain aspect ratio
        const aspectRatio = originalWidth / originalHeight;
        let scaledWidth = originalWidth;
        let scaledHeight = originalHeight;

        if (originalWidth > maxImageWidth || originalHeight > maxImageHeight) {
          if (aspectRatio > 1) {
            // Landscape
            scaledWidth = maxImageWidth;
            scaledHeight = maxImageWidth / aspectRatio;
          } else {
            // Portrait or square
            scaledHeight = maxImageHeight;
            scaledWidth = maxImageHeight * aspectRatio;
          }
        }

        // Center image in container
        const imageX = containerX + (containerWidth - scaledWidth) / 2;
        const imageY = containerY;

        slide.addImage({
          path: image,
          x: imageX,
          y: imageY,
          w: scaledWidth,
          h: scaledHeight
        });
      } catch (err) {
        console.error('Error loading CoverImage:', err);
      }
      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const pnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            // Split by words, chunk into 2 lines, then join with newline
            const fullName = `${catalogItem.productname || ''}`;
            const words = fullName.split(' ');
            const line1 = words.slice(0, 6).join(' '); // Adjust word count as needed
            const line2 = words.slice(6, 12).join(' ');
            const truncatedText = [line1, line2].filter(Boolean).join('\n');
            const pnameValCell = {
              text: truncatedText,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              pnameAttrCell,
              { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsize')) {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `Size`,
                    options: {
                      fontSize: 10,
                      fontFace: 'Arial',
                      color: '#000000',
                      fill: '#afafaf',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'Arial',
                      color: '#595959',
                      fill: '#E5E4E2',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let allSize;
                  if (product.attributes.SetStatus === 'Set') {
                    allSize = catalogueCatProductSize.filter(
                      item => item.CatalogueProduct === catalogItem.CatalogProduct
                    );

                    const sizeValues = allSize
                      .slice(0, 3)
                      .map(item => {
                        const { Description, Length, Width, Height, Unit } = item;

                        if (Length === 0 && Width === 0 && Height === 0) {
                          return '';
                        }

                        const descText = Description !== 'null' ? `${Description} - ` : '';
                        return `${descText}${Length} x ${Width} x ${Height} ${Unit}`;
                      })
                      .join('\n'); // Joining values with a new line for better readability

                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Arial',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'top'
                      }
                    };

                    const sizeValCell = {
                      text: sizeValues, // All values in a single cell
                      options: {
                        fontSize: 8,
                        fontFace: 'Arial',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };

                    tableRows.push([sizeAttrCell, sizeValCell]); // Adding a single row
                  } else {
                    const convertedLen = convertDimension(catalogItem.len, catalogItem.unit, unit);

                    const convertedWid = convertDimension(catalogItem.wid, catalogItem.unit, unit);

                    const convertedThick = convertDimension(
                      catalogItem.thick,
                      catalogItem.unit,
                      unit
                    );

                    const sizeValue =
                      convertedLen == 0 && convertedWid == 0 && convertedThick == 0
                        ? ''
                        : `${convertedLen} x ${convertedWid} x ${convertedThick} ${unit}`;
                    // const sizeValue =
                    //   catalogItem.len == 0 && catalogItem.wid == 0 && catalogItem.thick == 0
                    //     ? ''
                    //     : `${catalogItem.len} x ${catalogItem.wid} x ${catalogItem.thick} ${catalogItem.unit}`;
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Raleway',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: ` ${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'Raleway',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }
          if (selectedItems.includes('productMaterialName')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );
              // const matName = allSize.map(item => item.MatName || '').join('/');
              const matName = allSize
                .map(item => item.MatName) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const MaterialNameAttrCell = {
                text: `${label[0]?.attributes.MaterialName}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const MaterialNameValCell = {
                text: `${matName}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                MaterialNameAttrCell,
                { ...MaterialNameValCell, options: { ...MaterialNameValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productfinish')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              // const finishValues = allSize.map(item => item.FinishCode || '').join('/');
              const finishValues = allSize
                .map(item => {
                  const matchedFinish = finish.data.find(
                    finish => finish.attributes.FinishCode === item.FinishCode
                  );
                  return matchedFinish ? matchedFinish.attributes.FinishName : null;
                })
                .filter(value => value !== null) // Remove null values
                .join(' / ');

              // Join with "/"

              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: `${finishValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: ` ${catalogItem.finish}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productsalepri')) {
            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;
            // let price = '';
            // if ('currency' in catalogItem && 'saleprice' in catalogItem) {
            //   price =
            //     catalogItem.saleprice === 0 ? '' : `${catalogItem.saleprice} ${catalogItem.currency}`;
            // }
            // let allSize;
            // if (product.attributes.SetStatus === 'Set') {
            //   allSize = catalogueCatProductSize.filter(
            //     item => item.CatalogueProduct === catalogItem.CatalogProduct
            //   );
            //   console.log('allSize', allSize);
            //   // return ;
            //   price = allSize
            //     .map(item => item.Rate) // Extract NetWt values
            //     .filter(value => value !== null && value !== '') // Remove null or empty values
            //     .join('/'); //
            // }

            const sizeAttrCell = {
              text: 'Price',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text:
                formattedPrice,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              const NetWtValues = allSize
                .map(item => (item.NetWt == 0 ? '' : `${item.NetWt} Kg`)) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: `${NetWtValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: catalogItem.netwgt === 0 ? '' : `${catalogItem.netwgt} Kg`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: catalogItem.cbm === 0 ? '' : `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productInnerAndMaster')) {
            let innerData = product.attributes.Packaging.filter(
              item => item.CartonType === 'inner'
            );
            let masterData = product.attributes.Packaging.filter(
              item => item.CartonType === 'master'
            );
            let innerValue =
              innerData.length <= 0
                ? 0
                : innerData.length === 1
                ? innerData[0].Carton_PCS
                : innerData.reduce((sum, item) => sum + item.Carton_PCS, 0);
            let masterValue =
              masterData.length <= 0 ? 0 : masterData.length === 1 ? masterData[0].Carton_PCS : 1;
            const sizeAttrCell = {
              text: 'Inner/Master',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: `${innerValue} / ${masterValue}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productMoq')) {
            const sizeAttrCell = {
              text: `${label[0]?.attributes.MOQ}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: product.attributes.MOQ == '0' ? '' : `${product.attributes.MOQ} Pcs`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('ptech')) {
            const ptAttrCell = {
              text: `${label[0]?.attributes.P_Technique}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ptValCell = {
              text: `${product?.attributes?.P_Technique}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ptAttrCell,
              { ...ptValCell, options: { ...ptValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('madeby')) {
            const mdAttrCell = {
              text: `${label[0]?.attributes.MadeBy}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const mdValCell = {
              text: `${product?.attributes?.MadeBy}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              mdAttrCell,
              { ...mdValCell, options: { ...mdValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: 5.5,
        y: 0.9,
        // w: '40%', // Adjust the width of the table as needed
        colW: [1.6, 2.7],
        fontSize: 6, // Adjust the font size as needed
        fontFace: 'Arial' // Set the font face
        // autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    const reversedCata = [...cata.reverse()];
    let serialCounter = 1;
    setLoadPPT(true);
    for (let item of reversedCata) {
      await addProductSlide(item, serialCounter, cataloguecatappt);
      serialCounter++; // Ensure to await each slide creation
    }
    // Download the PPT file
    await addLastSlideSafe({
      ppt,
      buyercata,
      catappt,
      ip
    });
    ppt
      .writeFile({ fileName: `${cataName} PPt.pptx` })
      .then(res => {
        setLoadPPT(false);
        setOpenAttri(false);
      })
      .catch(err => console.log(err));
    // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });
    setOpen(false);
    setOpenAttri(false);
  };
const handleDownloadPPT18 = async (
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  buyercata,
  setLoadPPT
) => {
  console.log('handleDownloadPPT18');
  // const ppt = new pptxgen();
  // Helper function to add a slide with the product image and attributes
  const getImageSize = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = err => {
        reject(err);
      };
      img.src = imageUrl;
    });
  };

  const addHeaderToSlide = slide => {
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
    const container = {
      x: 0, // Horizontal position (left)
      y: 0, // Vertical position (top)
      w: 10, // Full width of the slide (adjust as needed)
      h: 1 // Height of the container (adjust as needed)
      // fill: { color: 'FF0000' }
    };
    slide.addShape('rect', container);

    if (logoImageUrl) {
      const logoFullPath = `${ip}${logoImageUrl}`;

      // Load the image to get its natural dimensions
      const image = new Image();
      image.src = logoFullPath;

      image.onload = () => {
        const { naturalWidth, naturalHeight } = image;

        // Maintain aspect ratio and scale to fit the container
        const containerAspectRatio = container.w / container.h;
        const imageAspectRatio = naturalWidth / naturalHeight;

        let scaledWidth, scaledHeight, offsetX, offsetY;

        if (imageAspectRatio > containerAspectRatio) {
          // Image is wider than the container
          scaledWidth = container.w;
          scaledHeight = container.w / imageAspectRatio;
          offsetX = 0;
          offsetY = (container.h - scaledHeight) / 2; // Center vertically
        } else {
          // Image is taller or equal aspect ratio
          scaledWidth = container.h * imageAspectRatio;
          scaledHeight = container.h;
          offsetX = (container.w - scaledWidth) / 2; // Center horizontally
          offsetY = 0;
        }

        // Add the image to the slide
        slide.addImage({
          path: logoFullPath,
          x: container.x + offsetX,
          y: container.y + offsetY,
          w: scaledWidth,
          h: scaledHeight
        });
      };

      image.onerror = () => {
        console.error('Error loading image:', logoFullPath);
      };
    }
  };

  const addIntroductionSlide = ppt => {
    const slide = ppt.addSlide();
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const email = firstItem?.attributes.email_id || '';
    const wesite = firstItem?.attributes.website || '';
    const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
    const headerBackground = {
      x: 0,
      y: 0,
      w: '100%', // Width spans the entire slide
      h: 5.6, // Height of the header area
      fill: '#eff1f0' // Background color for the header
    };
    slide.addShape('rect', headerBackground);
    const headerBackground1 = {
      x: 1,
      y: 4.5,
      w: '10%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#2f7a7c' // Background color for the header
    };
    slide.addShape('rect', headerBackground1);
    const headerBackground2 = {
      x: 2.1,
      y: 4.5,
      w: '74%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#afafaf' // Background color for the header
    };
    slide.addShape('rect', headerBackground2);
    // Add the logo image if the URL is available
    if (logoImageUrl) {
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      const logoFullPath = `${ip}${logoImageUrl}`;
      slide.addImage({ path: logoFullPath, ...logoOptions });
    }
    // Customize the content of the introduction slide as needed
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
        }
      ],
      { x: 1.8, y: 2.1, align: 'center' }
    );
    slide.addText(address, {
      x: 1.6,
      y: 2.5,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#303030',
      align: 'center'
    });
    slide.addText(email, {
      x: 0.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    slide.addText(wesite, {
      x: 2.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    // Add more text or content as desired
  };

  // const catacover = catappt[0]?.attributes?.CoverSlide;
  // if (catacover == 'Yes') {
  //   addIntroductionSlide();
  // }
  // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
  // if (catacoverb == 'Yes') {
  //   addIntroductionSlide();
  // }
  // const catah = catappt[0]?.attributes?.Header;
  // const catahb = buyercata[0]?.attributes?.Header;

  const addProductSlide = async (product, serialCounter, catah, catahb, ppt) => {
    const slide = ppt.addSlide();

    if (catah === 'Yes') {
      addHeaderToSlide(slide);
    }
    if (catahb === 'Yes') {
      addHeaderToSlide(slide);
    }

    try {
      const coverImageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      const containerWidth = 8.5;
      const containerHeight = 4.5;

      const slideWidth = 10;
      const slideHeight = 4.625;

      const containerX = (slideWidth - containerWidth) / 2;
      const containerY = (slideHeight - containerHeight) / 2;

      let coverImage = coverImageUrl;

      // Apply watermark if enabled
      if (watermark && watermarkUrl) {
        const mergedImageBase64 = await mergeImagesWithWatermark(coverImageUrl, watermarkUrl);
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' });
        coverImage = URL.createObjectURL(blob);
      }

      // Use fixed fallback dimensions if getImageSize fails
      let originalWidth = 1000;
      let originalHeight = 1000;

      try {
        const size = await getImageSize(coverImageUrl);
        originalWidth = size.width;
        originalHeight = size.height;
      } catch (e) {
        console.warn('Could not determine image size. Using default fallback.');
      }

      // Calculate scaled size (never exceeding container bounds)
      const aspectRatio = originalWidth / originalHeight;

      let scaledWidth = containerWidth;
      let scaledHeight = scaledWidth / aspectRatio;

      if (scaledHeight > containerHeight) {
        scaledHeight = containerHeight;
        scaledWidth = containerHeight * aspectRatio;
      }

      const imageX = containerX + (containerWidth - scaledWidth) / 2;
      const imageY = containerY + (containerHeight - scaledHeight) / 2;

      slide.addImage({
        path: coverImage,
        x: imageX,
        y: imageY + 0.9,
        w: scaledWidth,
        h: scaledHeight
      });
    } catch (err) {
      console.error('Error adding CoverImage:', err);
    }
  };

  // const reversedCata = [...cata];
  // let serialCounter = 1;
  // setLoadPPT(true);
  // for (let item of reversedCata) {
  //   await addProductSlide(item, serialCounter);
  //   serialCounter++; // Ensure to await each slide creation
  // }
  // // Download the PPT file
  // ppt
  //   .writeFile({ fileName: `${cataName} PPt.pptx` })
  //   .then(res => {
  //     setLoadPPT(false);
  //   })
  //   .catch(err => console.log(err));
  // // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

  setLoadPPT(true);

  let catalogueIndex = 1;

  // Check if `cata` is a flat array (not a multidimensional array)
  if (Array.isArray(cata) && !Array.isArray(cata[0])) {
    // If `cata` is a flat array, process all products directly
    const ppt = new pptxgen();

    const catacover = catappt[0]?.attributes?.CoverSlide;
    const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // const headerimg = catappt[0]?.attributes?.HPath;
    // const headerimgb = buyercata[0]?.attributes?.HPath;
    const catah = catappt[0]?.attributes?.Header;
    const catahb = buyercata[0]?.attributes?.Header;

    // Add introduction slide if needed
    if (catacover === 'Yes' || catacoverb === 'Yes') {
      await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
    }

    let serialCounter = 1;
    for (let product of cata) {
      // Ensure product is valid before adding slide
      if (product) {
        await addProductSlide(product, serialCounter, catah, catahb, ppt); // Pass ppt is not needed
        serialCounter++;
      } else {
        console.warn('Skipping invalid product:', product);
      }
    }

    // Generate the final PowerPoint file
    const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
    await addLastSlideSafe({
      ppt,
      buyercata,
      catappt,
      ip
    });
    await ppt.writeFile({ fileName });

    catalogueIndex++;
  } else {
    // If `cata` is a multidimensional array (e.g., array of catalogues)
    for (let catalogue of cata) {
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed
      }

      let serialCounter = 1;
      for (let product of catalogue) {
        await addProductSlide(product, serialCounter, catah, catahb, ppt); // Pass ppt is not needed
        serialCounter++;
      }

      const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    }
  }

  setLoadPPT(false);
};

const handleDownloadPPT19 = async (
  cata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  buyercata,
  setLoadPPT
) => {
  console.log('handleDownloadPPT19');
  // const ppt = new pptxgen();
  // Helper function to add a slide with the product image and attributes
  const getImageSize = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = err => {
        reject(err);
      };
      img.src = imageUrl;
    });
  };

  const addHeaderToSlide = slide => {
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
    const container = {
      x: 0, // Horizontal position (left)
      y: 0, // Vertical position (top)
      w: 10, // Full width of the slide (adjust as needed)
      h: 1 // Height of the container (adjust as needed)
      // fill: { color: 'FF0000' }
    };
    slide.addShape('rect', container);

    if (logoImageUrl) {
      const logoFullPath = `${ip}${logoImageUrl}`;

      // Load the image to get its natural dimensions
      const image = new Image();
      image.src = logoFullPath;

      image.onload = () => {
        const { naturalWidth, naturalHeight } = image;

        // Maintain aspect ratio and scale to fit the container
        const containerAspectRatio = container.w / container.h;
        const imageAspectRatio = naturalWidth / naturalHeight;

        let scaledWidth, scaledHeight, offsetX, offsetY;

        if (imageAspectRatio > containerAspectRatio) {
          // Image is wider than the container
          scaledWidth = container.w;
          scaledHeight = container.w / imageAspectRatio;
          offsetX = 0;
          offsetY = (container.h - scaledHeight) / 2; // Center vertically
        } else {
          // Image is taller or equal aspect ratio
          scaledWidth = container.h * imageAspectRatio;
          scaledHeight = container.h;
          offsetX = (container.w - scaledWidth) / 2; // Center horizontally
          offsetY = 0;
        }

        // Add the image to the slide
        slide.addImage({
          path: logoFullPath,
          x: container.x + offsetX,
          y: container.y + offsetY,
          w: scaledWidth,
          h: scaledHeight
        });
      };

      image.onerror = () => {
        console.error('Error loading image:', logoFullPath);
      };
    }
  };

  const addIntroductionSlide = ppt => {
    const slide = ppt.addSlide();
    const firstItem = catappt.length > 0 ? catappt[0] : null;
    const companyName = firstItem?.attributes.cmpnm || '';
    const address = firstItem?.attributes.address || '';
    const email = firstItem?.attributes.email_id || '';
    const wesite = firstItem?.attributes.website || '';
    const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
    const headerBackground = {
      x: 0,
      y: 0,
      w: '100%', // Width spans the entire slide
      h: 5.6, // Height of the header area
      fill: '#eff1f0' // Background color for the header
    };
    slide.addShape('rect', headerBackground);
    const headerBackground1 = {
      x: 1,
      y: 4.5,
      w: '10%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#2f7a7c' // Background color for the header
    };
    slide.addShape('rect', headerBackground1);
    const headerBackground2 = {
      x: 2.1,
      y: 4.5,
      w: '74%', // Width spans the entire slide
      h: 0.5, // Height of the header area
      fill: '#afafaf' // Background color for the header
    };
    slide.addShape('rect', headerBackground2);
    // Add the logo image if the URL is available
    if (logoImageUrl) {
      const logoOptions = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      const logoFullPath = `${ip}${logoImageUrl}`;
      slide.addImage({ path: logoFullPath, ...logoOptions });
    }
    // Customize the content of the introduction slide as needed
    slide.addText(
      [
        {
          text: companyName,
          options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
        }
      ],
      { x: 1.8, y: 2.1, align: 'center' }
    );
    slide.addText(address, {
      x: 1.6,
      y: 2.5,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#303030',
      align: 'center'
    });
    slide.addText(email, {
      x: 0.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    slide.addText(wesite, {
      x: 2.3,
      y: 4.8,
      fontSize: 14,
      fontFace: 'Times New Roman',
      color: '#ffffff',
      align: 'center'
    });
    // Add more text or content as desired
  };

  // const catacover = catappt[0]?.attributes?.CoverSlide;
  // if (catacover == 'Yes') {
  //   addIntroductionSlide();
  // }
  // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
  // if (catacoverb == 'Yes') {
  //   addIntroductionSlide();
  // }
  // const catah = catappt[0]?.attributes?.Header;
  // const catahb = buyercata[0]?.attributes?.Header;
  const addProductSlide = async (product, serialNumber, catah, catahb, ppt) => {
    const slide = ppt.addSlide();

    if (catah == 'Yes') {
      addHeaderToSlide(slide);
    }
    if (catahb == 'Yes') {
      addHeaderToSlide(slide);
    }

    try {
      const containerWidth = 4; // Container width in inches
      const containerHeight = 2.1; // Container height in inches

      // Create a red background for the container
      const containerOptions = {
        x: 0.5, // Starting X position for the container
        y: 1.1, // Starting Y position for the container
        w: containerWidth,
        h: containerHeight
      };

      // Add the rectangle container to the slide
      slide.addShape('rect', containerOptions);

      // Add the CoverImage to the container
      const coverImageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
      const imageWidth = 5.7; // Adjust the width of each image
      const imageHeight = 4.5;

      const { width: coverImageWidth, height: coverImageHeight } = await getImageSize(
        coverImageUrl
      );
      let coverImage = coverImageUrl;

      if (watermark && watermarkUrl) {
        const mergedImageBase64 = await mergeImagesWithWatermark(coverImageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' });

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        coverImage = imageUrl2;
      }

      // Scale image to fit within the bounding box while preserving aspect ratio
      const coverImageAspectRatio = coverImageWidth / coverImageHeight;
      let scaledWidth = coverImageWidth;
      let scaledHeight = coverImageHeight;

      if (coverImageWidth > imageWidth || coverImageHeight > imageHeight) {
        if (coverImageAspectRatio > 1) {
          // Landscape image: scale by width
          scaledWidth = imageWidth;
          scaledHeight = imageWidth / coverImageAspectRatio;
        } else {
          // Portrait or square image: scale by height
          scaledHeight = imageHeight;
          scaledWidth = imageHeight * coverImageAspectRatio;
        }
      }

      // Center the image within the container
      const xOffset = (containerWidth - scaledWidth) / 2; // Center horizontally
      const yOffset = 0; // Center vertically

      // Image options with centered position
      const imageOptions = {
        x: 1.2 + xOffset, // Account for the left margin of the container
        y: 1.1 + yOffset, // Account for the top margin of the container
        w: scaledWidth,
        h: scaledHeight
      };

      // Add the CoverImage to the container
      slide.addImage({ path: coverImage, ...imageOptions });
    } catch (err) {
      console.error('Error creating container or adding CoverImage:', err);
    }

    // Add Multiple Images (if available)
    try {
      let multipleImages = product?.attributes?.MultipleImage?.data || [];

      if (multipleImages.length > 0) {
        // ✅ Sort by file name (case-insensitive)
        multipleImages = [...multipleImages].sort((a, b) =>
          a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
        );
        const containerWidth = 3.9; // Container width in inches
        const containerHeight = 2.1; // Container height in inches

        // Define the top-left corner of the containers
        const containerPositions = [
          { x: 5.8, y: 1 }, // Top right
          { x: 5.8, y: 3.19 } // Bottom right
        ];

        for (let i = 0; i < Math.min(2, multipleImages.length); i++) {
          const img = multipleImages[i];
          const imageUrl = `${ip}${img?.attributes?.url}`;

          try {
            // Get original image dimensions
            const { width: originalWidth, height: originalHeight } = await getImageSize(imageUrl);
            let image = imageUrl;

            // Apply watermark if needed
            if (watermark && watermarkUrl) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' });
              image = URL.createObjectURL(blob);
            }

            // Calculate scaled size while maintaining aspect ratio
            const aspectRatio = originalWidth / originalHeight;
            let scaledWidth = containerWidth;
            let scaledHeight = containerWidth / aspectRatio;

            if (scaledHeight > containerHeight) {
              scaledHeight = containerHeight;
              scaledWidth = containerHeight * aspectRatio;
            }

            // Center image inside its container
            const container = containerPositions[i];
            const xCentered = container.x + (containerWidth - scaledWidth) / 2;
            const yCentered = container.y + (containerHeight - scaledHeight) / 2;

            // Add image to slide
            slide.addImage({
              path: image,
              x: xCentered - 0.2,
              y: yCentered + 0.1,
              w: scaledWidth,
              h: scaledHeight
            });
          } catch (err) {
            console.error('Error loading or processing image:', err);
          }
        }
      }
    } catch (err) {
      console.error('Error creating or adding MultipleImages:', err);
    }
  };

  // const reversedCata = [...cata];
  // let serialCounter = 1;
  // setLoadPPT(true);
  // for (let item of reversedCata) {
  //   await addProductSlide(item, serialCounter);
  //   serialCounter++; // Ensure to await each slide creation
  // }
  // // Download the PPT file
  // ppt
  //   .writeFile({ fileName: `${cataName} PPt.pptx` })
  //   .then(res => {
  //     setLoadPPT(false);
  //   })
  //   .catch(err => console.log(err));
  // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

  setLoadPPT(true);

  let catalogueIndex = 1;

  // Check if `cata` is a flat array (not a multidimensional array)
  if (Array.isArray(cata) && !Array.isArray(cata[0])) {
    // If `cata` is a flat array, process all products directly
    const ppt = new pptxgen();

    const catacover = catappt[0]?.attributes?.CoverSlide;
    const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // const headerimg = catappt[0]?.attributes?.HPath;
    // const headerimgb = buyercata[0]?.attributes?.HPath;
    const catah = catappt[0]?.attributes?.Header;
    const catahb = buyercata[0]?.attributes?.Header;

    // Add introduction slide if needed
    if (catacover === 'Yes' || catacoverb === 'Yes') {
      await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
    }

    let serialCounter = 1;
    for (let product of cata) {
      // Ensure product is valid before adding slide
      if (product) {
        await addProductSlide(product, serialCounter, catah, catahb, ppt); // Pass ppt is not needed
        serialCounter++;
      } else {
        console.warn('Skipping invalid product:', product);
      }
    }

    // Generate the final PowerPoint file
    const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
    await addLastSlideSafe({
      ppt,
      buyercata,
      catappt,
      ip
    });
    await ppt.writeFile({ fileName });

    catalogueIndex++;
  } else {
    // If `cata` is a multidimensional array (e.g., array of catalogues)
    for (let catalogue of cata) {
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed
      }

      let serialCounter = 1;
      for (let product of catalogue) {
        await addProductSlide(product, serialCounter, catah, catahb, ppt); // Pass ppt is not needed
        serialCounter++;
      }

      const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    }
  }
  setLoadPPT(false);
};
const handleDownloadPPT20 = async (
  cata,
  buyercata,
  catappt,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  setLoadPPT,
  setOpenAttri,
  setOpen,
  cataName,
  cataloguecatappt,
  label,
  catalogueCatProductSize,
  sizeshow,
   unit = 'cm',
  currency = 'USD',
  selectedRate,
  ...selectedItems
) =>
  // productAlias,
  // productcategory,
  // productName,
  // producttype,
  // productdesc,
  // productsizerange,
  // productsize,
  // productfinish,
  // productntw,
  // productsalepri,
  // productremark,
  // productcbm,
  // productMaterialName,
  // productInnerAndMaster,
  // productMoq,
  // ptech,
  // madeby
  {
    console.log('handleDownloadPPT20');
    // const ppt = new pptxgen();
    // Helper function to add a slide with the product image and attributes
    const getImageSize = imageUrl => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = err => {
          reject(err);
        };
        img.src = imageUrl;
      });
    };

    const response = await fetch(`${ip}/api/mstfinishes?populate=*&pagination[pageSize]=100000`);
    const finish = await response.json();

    const addHeaderToSlide = slide => {
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const logoImageUrl = firstItem?.attributes?.HPath?.data?.attributes?.url || '';
      const container = {
        x: 0, // Horizontal position (left)
        y: 0, // Vertical position (top)
        w: 10, // Full width of the slide (adjust as needed)
        h: 1 // Height of the container (adjust as needed)
        // fill: { color: 'FF0000' }
      };
      slide.addShape('rect', container);

      if (logoImageUrl) {
        const logoFullPath = `${ip}${logoImageUrl}`;

        // Load the image to get its natural dimensions
        const image = new Image();
        image.src = logoFullPath;

        image.onload = () => {
          const { naturalWidth, naturalHeight } = image;

          // Maintain aspect ratio and scale to fit the container
          const containerAspectRatio = container.w / container.h;
          const imageAspectRatio = naturalWidth / naturalHeight;

          let scaledWidth, scaledHeight, offsetX, offsetY;

          if (imageAspectRatio > containerAspectRatio) {
            // Image is wider than the container
            scaledWidth = container.w;
            scaledHeight = container.w / imageAspectRatio;
            offsetX = 0;
            offsetY = (container.h - scaledHeight) / 2; // Center vertically
          } else {
            // Image is taller or equal aspect ratio
            scaledWidth = container.h * imageAspectRatio;
            scaledHeight = container.h;
            offsetX = (container.w - scaledWidth) / 2; // Center horizontally
            offsetY = 0;
          }

          // Add the image to the slide
          slide.addImage({
            path: logoFullPath,
            x: container.x + offsetX,
            y: container.y + offsetY,
            w: scaledWidth,
            h: scaledHeight
          });
        };

        image.onerror = () => {
          console.error('Error loading image:', logoFullPath);
        };
      }
    };

    const addIntroductionSlide = ppt => {
      const slide = ppt.addSlide();
      const firstItem = catappt.length > 0 ? catappt[0] : null;
      const companyName = firstItem?.attributes.cmpnm || '';
      const address = firstItem?.attributes.address || '';
      const email = firstItem?.attributes.email_id || '';
      const wesite = firstItem?.attributes.website || '';
      const logoImageUrl = firstItem?.attributes.CSPath.data.attributes.url || '';
      const headerBackground = {
        x: 0,
        y: 0,
        w: '100%', // Width spans the entire slide
        h: 5.6, // Height of the header area
        fill: '#eff1f0' // Background color for the header
      };
      slide.addShape('rect', headerBackground);
      const headerBackground1 = {
        x: 1,
        y: 4.5,
        w: '10%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#2f7a7c' // Background color for the header
      };
      slide.addShape('rect', headerBackground1);
      const headerBackground2 = {
        x: 2.1,
        y: 4.5,
        w: '74%', // Width spans the entire slide
        h: 0.5, // Height of the header area
        fill: '#afafaf' // Background color for the header
      };
      slide.addShape('rect', headerBackground2);
      // Add the logo image if the URL is available
      if (logoImageUrl) {
        const logoOptions = {
          x: 0,
          y: 0,
          w: '100%', // Width spans the entire slide
          h: 5.6, // Height of the header area
          fill: '#eff1f0' // Background color for the header
        };
        // const logoOptions = {
        //   x: 1.2, // Adjust the x-coordinate of the logo
        //   y: 0.6, // Adjust the y-coordinate of the logo
        //   w: 1, // Adjust the width of the logo
        //   h: 0.3 // Adjust the height of the logo
        // };
        const logoFullPath = `${ip}${logoImageUrl}`;
        slide.addImage({ path: logoFullPath, ...logoOptions });
      }
      // Customize the content of the introduction slide as needed
      slide.addText(
        [
          {
            text: companyName,
            options: { fontSize: 18, fontFace: 'Aileron Black', color: '#303030' }
          }
        ],
        { x: 1.8, y: 2.1, align: 'center' }
      );
      slide.addText(address, {
        x: 1.6,
        y: 2.5,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#303030',
        align: 'center'
      });
      slide.addText(email, {
        x: 0.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      slide.addText(wesite, {
        x: 2.3,
        y: 4.8,
        fontSize: 14,
        fontFace: 'Times New Roman',
        color: '#ffffff',
        align: 'center'
      });
      // Add more text or content as desired
    };

    // const catacover = catappt[0]?.attributes?.CoverSlide;
    // if (catacover == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catacoverb = buyercata[0]?.attributes?.CoverSlide;
    // if (catacoverb == 'Yes') {
    //   addIntroductionSlide();
    // }
    // const catah = catappt[0]?.attributes?.Header;
    // const catahb = buyercata[0]?.attributes?.Header;
    const addProductSlide = async (product, serialNumber, catalgoue, catah, catahb, ppt) => {
      const slide = ppt.addSlide();

      if (catah == 'Yes') {
        addHeaderToSlide(slide);
      }
      if (catahb == 'Yes') {
        addHeaderToSlide(slide);
      }

      try {
        const containerX = 0.05;
        const containerY = 0.9;
        const containerWidth = 5; // in inches
        const containerHeight = 2.9; // in inches

        // Add a container rectangle (optional visualization)
        slide.addShape('rect', {
          x: containerX,
          y: containerY,
          w: containerWidth,
          h: containerHeight
          // fill: 'red' // Uncomment to debug the container box
        });

        // ---- COVER IMAGE ----
        const coverImageUrl = `${ip}${product?.attributes?.CoverImage?.data?.attributes?.url}`;
        const { width: cw, height: ch } = await getImageSize(coverImageUrl);
        let coverImage = coverImageUrl;

        if (watermark && watermarkUrl) {
          const merged = await mergeImagesWithWatermark(coverImageUrl, watermarkUrl);
          const res = await fetch(merged);
          const buf = await res.arrayBuffer();
          coverImage = URL.createObjectURL(new Blob([buf], { type: 'image/png' }));
        }

        // Calculate aspect ratio and scaled dimensions
        const coverAspect = cw / ch;

        let scaledH = containerHeight;
        let scaledW = scaledH * coverAspect;

        // if (scaledH > containerHeight) {
        //   // Scale down further if height still exceeds container
        //   scaledH = containerHeight;
        //   scaledW = scaledH * coverAspect;
        // }

        const offsetX = (containerWidth - scaledW) / 2;
        const offsetY = (containerHeight - scaledH) / 2;

        slide.addImage({
          path: coverImage,
          x: containerX + offsetX,
          y: containerY + offsetY,
          w: scaledW,
          h: scaledH
        });
        const finalCoverWidth = scaledW;
        const finalCoverHeight = scaledH;
        // ---- MULTIPLE IMAGES BELOW ----
        let multipleImages = product.attributes.MultipleImage?.data || [];
        multipleImages = [...multipleImages].sort((a, b) =>
          a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
        );

        slide.addShape('rect', {
          x: containerX + offsetX,
          y: containerY + finalCoverHeight + 0.1,
          w: finalCoverWidth,
          h: 1.6
          // fill: 'red' // Uncomment to debug the container box
        });

        const imageCount = Math.min(2, multipleImages.length);
        if (imageCount > 0) {
          const spacing = 0.1;
          const totalMultipleWidth = finalCoverWidth;
          const imageW = (totalMultipleWidth - (imageCount - 1) * spacing) / imageCount;
          const imageH = imageW; // Square area allocated

          const startX = containerX + (containerWidth - totalMultipleWidth) / 2;
          const imageY = containerY + finalCoverHeight + 0.1; // Ensure it's clearly below cover image

          for (let i = 0; i < imageCount; i++) {
            const img = multipleImages[i];
            const imgUrl = `${ip}${img.attributes.url}`;
            const { width, height } = await getImageSize(imgUrl);
            let image = imgUrl;

            if (watermark && watermarkUrl) {
              const merged = await mergeImagesWithWatermark(imgUrl, watermarkUrl);
              const res = await fetch(merged);
              const buf = await res.arrayBuffer();
              image = URL.createObjectURL(new Blob([buf], { type: 'image/png' }));
            }

            // Scale to fit inside square area
            const ar = width / height;
            let w = imageW,
              h = imageH;
            if (ar > 1) {
              // Wide image
              h = w / ar;
            } else {
              // Tall image
              w = h * ar;
            }

            let x, y;
            if (imageCount === 1) {
              // Center single image horizontally
              w *= 0.5;
              h *= 0.5;
              x = containerX + (containerWidth - w) / 2;
              // y = containerY + containerHeight + 0.2;
            } else {
              // Multiple images: space them out
              x = startX + i * (imageW + spacing) + (imageW - w) / 2;
              // y = imageY + (imageH - h) / 2;
            }

            slide.addImage({
              path: image,
              x,
              y: imageY,
              w,
              h,
              fill: 'red'
            });
          }
        }
      } catch (err) {
        console.error('Error generating slide:', err);
      }

      const tableRows = [];
      let yOffset = 0.1; // Adjust the initial y-coordinate value

      catalgoue.forEach(catalogItem => {
        if (catalogItem.CatalogProduct == product.id) {
          if (selectedItems.includes('productAlias')) {
            const productidAttrCell = {
              text: `${label[0]?.attributes.AliasCode}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const productidValCell = {
              text: `${catalogItem.aliascd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              productidAttrCell,
              { ...productidValCell, options: { ...productidValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productcategory')) {
            const categoryNameAttrCell = {
              text: `${label[0]?.attributes.Category}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const categoryNameValCell = {
              text: `${catalogItem.catcd || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              categoryNameAttrCell,
              { ...categoryNameValCell, options: { ...categoryNameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('producttype')) {
            const producttypeAttrCell = {
              text: `${label[0]?.attributes.ProductType}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const producttypeValCell = {
              text: `${catalogItem.prodtypecd}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              producttypeAttrCell,
              { ...producttypeValCell, options: { ...producttypeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productName')) {
            const pnameAttrCell = {
              text: `${label[0]?.attributes.ProductName}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            // Split by words, chunk into 2 lines, then join with newline
            const fullName = `${catalogItem.productname || ''}`;
            const words = fullName.split(' ');
            const line1 = words.slice(0, 6).join(' '); // Adjust word count as needed
            const line2 = words.slice(6, 12).join(' ');
            const truncatedText = [line1, line2].filter(Boolean).join('\n');
            const pnameValCell = {
              text: truncatedText,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              pnameAttrCell,
              { ...pnameValCell, options: { ...pnameValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('productdesc')) {
            const discAttrCell = {
              text: `${label[0]?.attributes.Description}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const discValCell = {
              text: `${catalogItem.description || ''}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              discAttrCell,
              { ...discValCell, options: { ...discValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productsize')) {
            sizeshow
              ? // Handle `productsizerange`
                selectedItems.includes('productsizerange') &&
                (() => {
                  const sRangeAttrCell = {
                    text: `Size`,
                    options: {
                      fontSize: 10,
                      fontFace: 'Arial',
                      color: '#000000',
                      fill: '#afafaf',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  const sRangeValCell = {
                    text: `${catalogItem.SizeRange || 'N/A'}`,
                    options: {
                      fontSize: 8,
                      fontFace: 'Arial',
                      color: '#595959',
                      fill: '#E5E4E2',
                      border: { pt: 2, color: '#ffffff' },
                      valign: 'middle'
                    }
                  };
                  tableRows.push([
                    sRangeAttrCell,
                    { ...sRangeValCell, options: { ...sRangeValCell.options, y: yOffset } }
                  ]);
                  yOffset += 0.1;
                })()
              : // Handle `productsize`
                selectedItems.includes('productsize') &&
                (() => {
                  let allSize;
                  if (product.attributes.SetStatus === 'Set') {
                    allSize = catalogueCatProductSize.filter(
                      item => item.CatalogueProduct === catalogItem.CatalogProduct
                    );

                    const sizeValues = allSize
                      .slice(0, 3)
                      .map(item => {
                        const { Description, Length, Width, Height, Unit } = item;

                        if (Length === 0 && Width === 0 && Height === 0) {
                          return '';
                        }

                        const descText = Description !== 'null' ? `${Description} - ` : '';
                        return `${descText}${Length} x ${Width} x ${Height} ${Unit}`;
                      })
                      .join('\n'); // Joining values with a new line for better readability

                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Arial',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'top'
                      }
                    };

                    const sizeValCell = {
                      text: sizeValues, // All values in a single cell
                      options: {
                        fontSize: 8,
                        fontFace: 'Arial',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };

                    tableRows.push([sizeAttrCell, sizeValCell]); // Adding a single row
                  } else {
                    const convertedLen = convertDimension(catalogItem.len, catalogItem.unit, unit);

                    const convertedWid = convertDimension(catalogItem.wid, catalogItem.unit, unit);

                    const convertedThick = convertDimension(
                      catalogItem.thick,
                      catalogItem.unit,
                      unit
                    );

                    const sizeValue =
                      convertedLen == 0 && convertedWid == 0 && convertedThick == 0
                        ? ''
                        : `${convertedLen} x ${convertedWid} x ${convertedThick} ${unit}`;
                    // const sizeValue =
                    //   catalogItem.len == 0 && catalogItem.wid == 0 && catalogItem.thick == 0
                    //     ? ''
                    //     : `${catalogItem.len} x ${catalogItem.wid} x ${catalogItem.thick} ${catalogItem.unit}`;
                    const sizeAttrCell = {
                      text: `${label[0]?.attributes.Sizeunit}`,
                      options: {
                        fontSize: 10,
                        fontFace: 'Raleway',
                        color: '#000000',
                        fill: '#afafaf',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    const sizeValCell = {
                      text: ` ${sizeValue}`,
                      options: {
                        fontSize: 8,
                        fontFace: 'Raleway',
                        color: '#595959',
                        fill: '#E5E4E2',
                        border: { pt: 2, color: '#ffffff' },
                        valign: 'middle'
                      }
                    };
                    tableRows.push([
                      sizeAttrCell,
                      { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
                    ]);
                    yOffset += 0.1;
                  }
                })();
          }
          if (selectedItems.includes('productMaterialName')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );
              // const matName = allSize.map(item => item.MatName || '').join('/');
              const matName = allSize
                .map(item => item.MatName) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const MaterialNameAttrCell = {
                text: `${label[0]?.attributes.MaterialName}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const MaterialNameValCell = {
                text: `${matName}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                MaterialNameAttrCell,
                { ...MaterialNameValCell, options: { ...MaterialNameValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productfinish')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              // const finishValues = allSize.map(item => item.FinishCode || '').join('/');
              const finishValues = allSize
                .map(item => {
                  const matchedFinish = finish.data.find(
                    finish => finish.attributes.FinishCode === item.FinishCode
                  );
                  return matchedFinish ? matchedFinish.attributes.FinishName : null;
                })
                .filter(value => value !== null) // Remove null values
                .join(' / ');

              // Join with "/"

              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: `${finishValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const finisheAttrCell = {
                text: `${label[0]?.attributes.finish}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const finidhValCell = {
                text: ` ${catalogItem.finish}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                finisheAttrCell,
                { ...finidhValCell, options: { ...finidhValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productsalepri')) {
            let price = catalogItem.saleprice ? Number(catalogItem.saleprice) : 0;

            // Convert only if different currency
            if (currency !== catalogItem.currency && selectedRate > 0) {
              price = price / selectedRate;
            }

            // ✅ Create formatted string separately
            const formattedPrice = `${price.toFixed(2)} ${currency}`;
            // let price = '';
            // if ('currency' in catalogItem && 'saleprice' in catalogItem) {
            //   price =
            //     catalogItem.saleprice === 0 ? '' : `${catalogItem.saleprice} ${catalogItem.currency}`;
            // }
            // let allSize;
            // if (product.attributes.SetStatus === 'Set') {
            //   allSize = catalogueCatProductSize.filter(
            //     item => item.CatalogueProduct === catalogItem.CatalogProduct
            //   );
            //   console.log('allSize', allSize);
            //   // return ;
            //   price = allSize
            //     .map(item => item.Rate) // Extract NetWt values
            //     .filter(value => value !== null && value !== '') // Remove null or empty values
            //     .join('/'); //
            // }

            const sizeAttrCell = {
              text: 'Price',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text:
                formattedPrice,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productntw')) {
            if (product.attributes.SetStatus === 'Set') {
              const allSize = catalogueCatProductSize.filter(
                item => item.CatalogueProduct === catalogItem.CatalogProduct
              );

              const NetWtValues = allSize
                .map(item => (item.NetWt == 0 ? '' : `${item.NetWt} Kg`)) // Extract NetWt values
                .filter(value => value !== null && value !== '') // Remove null or empty values
                .join(' / '); // Join with "/"

              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: `${NetWtValues}`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            } else {
              const ntAttrCell = {
                text: `${label[0]?.attributes.NetWgt}`,
                options: {
                  fontSize: 10,
                  fontFace: 'Arial',
                  color: '#000000',
                  fill: '#afafaf',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              const ntValCell = {
                text: catalogItem.netwgt === 0 ? '' : `${catalogItem.netwgt} Kg`,
                options: {
                  fontSize: 8,
                  fontFace: 'Arial',
                  color: '#595959',
                  fill: '#E5E4E2',
                  border: { pt: 2, color: '#ffffff' },
                  valign: 'middle'
                }
              };
              tableRows.push([
                ntAttrCell,
                { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
              ]);
              yOffset += 0.1;
            }
          }
          if (selectedItems.includes('productcbm')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.cbm}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: catalogItem.cbm === 0 ? '' : `${catalogItem.cbm}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productInnerAndMaster')) {
            let innerData = product.attributes.Packaging.filter(
              item => item.CartonType === 'inner'
            );
            let masterData = product.attributes.Packaging.filter(
              item => item.CartonType === 'master'
            );
            let innerValue =
              innerData.length <= 0
                ? 0
                : innerData.length === 1
                ? innerData[0].Carton_PCS
                : innerData.reduce((sum, item) => sum + item.Carton_PCS, 0);
            let masterValue =
              masterData.length <= 0 ? 0 : masterData.length === 1 ? masterData[0].Carton_PCS : 1;
            const sizeAttrCell = {
              text: 'Inner/Master',
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: `${innerValue} / ${masterValue}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productMoq')) {
            const sizeAttrCell = {
              text: `${label[0]?.attributes.MOQ}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const sizeValCell = {
              text: product.attributes.MOQ == '0' ? '' : `${product.attributes.MOQ} Pcs`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              sizeAttrCell,
              { ...sizeValCell, options: { ...sizeValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }

          if (selectedItems.includes('ptech')) {
            const ptAttrCell = {
              text: `${label[0]?.attributes.P_Technique}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ptValCell = {
              text: `${product?.attributes?.P_Technique}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ptAttrCell,
              { ...ptValCell, options: { ...ptValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('productremark')) {
            const ntAttrCell = {
              text: `${label[0]?.attributes.ProductRemark}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const ntValCell = {
              text: `${catalogItem.remark}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              ntAttrCell,
              { ...ntValCell, options: { ...ntValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
          if (selectedItems.includes('madeby')) {
            const mdAttrCell = {
              text: `${label[0]?.attributes.MadeBy}`,
              options: {
                fontSize: 10,
                fontFace: 'Arial',
                color: '#000000',
                fill: '#afafaf',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            const mdValCell = {
              text: `${product?.attributes?.MadeBy}`,
              options: {
                fontSize: 8,
                fontFace: 'Arial',
                color: '#595959',
                fill: '#E5E4E2',
                border: { pt: 2, color: '#ffffff' },
                valign: 'middle'
              }
            };
            tableRows.push([
              mdAttrCell,
              { ...mdValCell, options: { ...mdValCell.options, y: yOffset } }
            ]);
            yOffset += 0.1;
          }
        }
      });
      const tableOptions = {
        x: 5.5,
        y: 0.9,
        // w: '40%', // Adjust the width of the table as needed
        colW: [1.6, 2.7],
        fontSize: 6, // Adjust the font size as needed
        fontFace: 'Arial' // Set the font face
        // autoPage: true // Enable automatic paging if the table exceeds slide size
      };

      slide.addTable(tableRows, tableOptions);
    };
    // const reversedCata = [...cata];
    // let serialCounter = 1;
    // setLoadPPT(true);
    // for (let item of reversedCata) {
    //   await addProductSlide(item, serialCounter, cataloguecatappt);
    //   serialCounter++; // Ensure to await each slide creation
    // }
    // // Download the PPT file
    // ppt
    //   .writeFile({ fileName: `${cataName} PPt.pptx` })
    //   .then(res => {
    //     setLoadPPT(false);
    //     setOpenAttri(false);
    //   })
    //   .catch(err => console.log(err));
    // // ppt.writeFile({ fileName: `${cataName} PPt.pptx` });

    setLoadPPT(true);

    let catalogueIndex = 1;

    // Check if `cata` is a flat array (not a multidimensional array)
    if (Array.isArray(cata) && !Array.isArray(cata[0])) {
      // If `cata` is a flat array, process all products directly
      const ppt = new pptxgen();

      const catacover = catappt[0]?.attributes?.CoverSlide;
      const catacoverb = buyercata[0]?.attributes?.CoverSlide;
      // const headerimg = catappt[0]?.attributes?.HPath;
      // const headerimgb = buyercata[0]?.attributes?.HPath;
      const catah = catappt[0]?.attributes?.Header;
      const catahb = buyercata[0]?.attributes?.Header;

      // Add introduction slide if needed
      if (catacover === 'Yes' || catacoverb === 'Yes') {
        await addIntroductionSlide(ppt); // Pass ppt is not needed in this context
      }

      let serialCounter = 1;
      for (let product of cata) {
        // Ensure product is valid before adding slide
        if (product) {
          await addProductSlide(product, serialCounter, cataloguecatappt, catah, catahb, ppt); // Pass ppt is not needed
          serialCounter++;
        } else {
          console.warn('Skipping invalid product:', product);
        }
      }

      // Generate the final PowerPoint file
      const fileName = `${cataName || 'Catalogue'}_${catalogueIndex}.pptx`;
      await addLastSlideSafe({
        ppt,
        buyercata,
        catappt,
        ip
      });
      await ppt.writeFile({ fileName });

      catalogueIndex++;
    } else {
      // If `cata` is a multidimensional array (e.g., array of catalogues)
      for (let catalogue of cata) {
        const ppt = new pptxgen();

        const catacover = catappt[0]?.attributes?.CoverSlide;
        const catacoverb = buyercata[0]?.attributes?.CoverSlide;
        // const headerimg = catappt[0]?.attributes?.HPath;
        // const headerimgb = buyercata[0]?.attributes?.HPath;
        const catah = catappt[0]?.attributes?.Header;
        const catahb = buyercata[0]?.attributes?.Header;

        if (catacover === 'Yes' || catacoverb === 'Yes') {
          await addIntroductionSlide(ppt); // Pass ppt is not needed
        }

        let serialCounter = 1;
        for (let product of catalogue) {
          await addProductSlide(product, serialCounter, cataloguecatappt, catah, catahb, ppt); // Pass ppt is not needed
          serialCounter++;
        }

        const fileName = `${cataName[catalogueIndex - 1] || 'Catalogue'}.pptx`;
        await ppt.writeFile({ fileName });

        catalogueIndex++;
      }
    }
    setLoadPPT(false);
    setOpen(false);
    setOpenAttri(false);
  };
export {
  handleDownloadPPT1,
  handleDownloadPPT2,
  handleDownloadPPT3,
  handleDownloadPPT4,
  handleDownloadPPT5,
  handleDownloadPPT6,
  handleDownloadPPT7,
  handleDownloadPPT8,
  handleDownloadPPT9,
  handleDownloadPPT11,
  handleDownloadPPT12,
  handleDownloadPPT13,
  handleDownloadPPT14,
  handleDownloadPPT15,
  handleDownloadPPT16,
  handleDownloadPPT17,
  handleDownloadPPT18,
  handleDownloadPPT19,
  handleDownloadPPT20,
  generatePPTBlobForEmail
};
